import { infiniteQueryOptions, queryOptions, } from "@tanstack/react-query";
import { client } from "../client.gen";
import { categoryCreateCategory, categoryDeleteCategory, categoryGetAllCategoryIconSetting, categoryGetCategory, categoryGetCategoryImageUploadUrl, categoryListCategories, categoryListPublicCategories, categoryUpdateAllCategoryIconSetting, categoryUpdateCategory, contentManagementCreateBanner, contentManagementCreateContentPage, contentManagementCreateNotice, contentManagementDeleteBanner, contentManagementDeleteContentPage, contentManagementDeleteNotice, contentManagementGetBanner, contentManagementGetBannerImageUploadUrl, contentManagementGetContentFileUploadUrl, contentManagementGetContentPage, contentManagementGetNotice, contentManagementGetPublicContentPage, contentManagementGetPublicNotice, contentManagementListBanners, contentManagementListContentPages, contentManagementListNotices, contentManagementListPublicBanners, contentManagementListPublicNoticeBanners, contentManagementListPublicNoticePopups, contentManagementListPublicNotices, contentManagementUpdateBanner, contentManagementUpdateBannerDisplayOrders, contentManagementUpdateContentPage, contentManagementUpdateNotice, dealerBackofficeGetBuyerNewOrderGroup, dealerBackofficeGetDashboardSummary, dealerBackofficeListBuyerHistories, dealerBackofficeListSalesHistory, identityCreateAdminAccount, identityCreateAdminLoginLockRelease, identityCreateAdminSession, identityCreateAdminTokenRefresh, identityCreateBackofficeDatabaseReset, identityCreateBackofficeDealerProxySession, identityCreateBackofficeForceNicknameChange, identityCreateBackofficeGrantDealerPermission, identityCreateBackofficeInterestCategoryRepromptRequest, identityCreateBackofficeRevokeDealerPermission, identityCreateBackofficeUserAdminMemo, identityCreateDealerProxyToken, identityCreateDeviceToken, identityCreateKakaoSession, identityCreateNaverToken, identityCreatePhoneVerification, identityCreatePhoneVerificationCode, identityCreateSocialSession, identityCreateSocialSignup, identityCreateUser, identityCreateUserActivation, identityCreateUserSession, identityCreateUserSuspension, identityCreateUserTokenRefresh, identityDeleteAdminAccount, identityDeleteDealerProxyToken, identityDeleteDeviceToken, identityDeleteUserAccount, identityGetAdminAccount, identityGetBackofficeAppVersionSummary, identityGetBackofficeNotificationSettingsSummary, identityGetBackofficeProfileImageUploadUrl, identityGetBackofficeUserAccount, identityGetBackofficeUserInterestCategories, identityGetInterestCategories, identityGetProfileImageUploadUrl, identityGetUser, identityListAdminAccounts, identityListAdminHistories, identityListAdminLoginLocks, identityListBackofficeUserAdminMemos, identityListBackofficeUserHistories, identityListDealerHistories, identityListUserAccounts, identitySearchUsers, identityUpdateAdminAccount, identityUpdateAdminPassword, identityUpdateAppInstallation, identityUpdateBackofficeUserInterestCategories, identityUpdateBackofficeUserProfileImage, identityUpdateInterestCategories, identityUpdateNotificationSettings, identityUpdatePhoneNumber, identityUpdateProfile, kpiGetBackofficeKpiDashboard, kpiListBackofficeKpiDashboardExports, ledgerCreateAccount, ledgerCreateControlAccountReconciliation, ledgerCreateJournalEntry, ledgerCreateReconciliation, ledgerCreateReversingJournalEntry, ledgerDeleteAccount, ledgerGetAccount, ledgerGetAccountBalance, ledgerGetDealerBalance, ledgerGetJournalEntry, ledgerGetReconciliationReport, ledgerGetTrialBalance, ledgerListAccounts, ledgerListDiscrepancies, ledgerListJournalEntries, ledgerListReconciliationReports, ledgerUpdateAccount, liveSnapshotCreateLiveSnapshot, liveSnapshotDeleteLiveSnapshot, liveSnapshotGetBackofficeLiveSnapshot, liveSnapshotGetLiveSnapshot, liveSnapshotGetLiveSnapshotImageUploadUrl, liveSnapshotListBackofficeLiveSnapshots, liveSnapshotListLiveSnapshotBuyers, liveSnapshotListLiveSnapshots, liveSnapshotPatchBackofficeLiveSnapshotHideStatus, liveSnapshotPatchBackofficeLiveSnapshotUnhideStatus, marketplacePaymentCreateBrandPayPaymentMethodDefault, marketplacePaymentDeleteBrandPayPaymentMethod, marketplacePaymentGetBrandPayRegistrationStatus, marketplacePaymentGetCallback, marketplacePaymentListBrandPayPaymentMethods, messagingCreateBackofficeOpenChatRoom, messagingCreateBackofficeOpenChatRoomClose, messagingCreateBackofficeOpenChatRoomKickUser, messagingCreateBackofficeOpenChatRoomUpdateCategory, messagingCreateBackofficeOpenChatRoomUpdateThumbnail, messagingCreateBackofficeOpenChatRoomUpdateTitle, messagingCreateBackofficeSupportChatMessage, messagingCreateBackofficeSupportChatReadReceipt, messagingCreateBackofficeSupportChatRoom, messagingCreateChatRoom, messagingCreateChatRoomImage, messagingCreateChatRoomMessage, messagingCreateChatRoomReadReceipt, messagingCreateDealerChatRoom, messagingCreateDealerChatRoomKickUser, messagingCreateOpenChatImage, messagingCreateOpenChatRoomMembership, messagingCreateOpenChatRoomMessage, messagingDeleteBackofficeOpenChatRoomKickedUser, messagingDeleteBackofficeOpenChatRoomMessage, messagingDeleteChatRoomMembership, messagingDeleteMessage, messagingDeleteOpenChatRoom, messagingDeleteOpenChatRoomMembership, messagingDeleteOpenChatRoomMessage, messagingGetBackofficeDealerChatRoomSettings, messagingGetBackofficeOpenChatRoomKickedUsers, messagingGetBackofficeOpenChatRoomThumbnailUploadUrl, messagingGetBackofficeSupportChatHistory, messagingGetChatHistory, messagingGetChatRoom, messagingGetDealerChatRoomCreationEligibility, messagingGetOpenChatRoom, messagingListBackofficeDmConversationMessages, messagingListBackofficeDmConversations, messagingListBackofficeMessages, messagingListBackofficeOpenChatRoomMessages, messagingListBackofficeOpenChatRooms, messagingListBackofficeSupportChatRooms, messagingListChatRooms, messagingListCommunityHomeOpenChatRooms, messagingListDealerChatRooms, messagingListMyChatRooms, messagingListOpenChatMessages, messagingListOpenChatRoomParticipants, messagingListOpenChatRooms, messagingUpdateBackofficeDealerChatRoomSettings, messagingUpdateOpenChatRoomNotice, notificationCreateBroadcastPushSendHistory, notificationCreateNotificationDispatch, notificationCreateNotificationDispatchCancellation, notificationCreateNotificationDispatchPreview, notificationCreateNotificationOpen, notificationGetNotificationOperationSettings, notificationGetNotificationPreferences, notificationListBackofficeNotifications, notificationListBackofficeNotificationSettingItems, notificationListBackofficeNotificationTemplates, notificationListBackofficeUserNotificationSettingItems, notificationListBroadcastPushSendHistories, notificationListNotificationDispatchAlimtalkTemplates, notificationListNotificationDispatches, notificationListNotifications, notificationListNotificationSettingItems, notificationListUnreadNotifications, notificationPatchNotification, notificationSearchNotificationDispatchRecipients, notificationUpdateAllNotificationsRead, notificationUpdateBackofficeNotificationSettingItem, notificationUpdateBackofficeNotificationTemplate, notificationUpdateNotificationOperationSettings, notificationUpdateNotificationPreferences, notificationUpdateNotificationSettingItem, ordersCreateBackofficeFulfillmentOrderForceCancelRefund, ordersCreateBackofficeOrderForceCancelRefund, ordersCreateBackofficeOrderShippingFeeRefund, ordersCreateBackofficeReturnForceApproveRefund, ordersCreateCancellationRequestBatchApproval, ordersCreateDeliveryAddress, ordersCreateDeliveryAddressDefault, ordersCreateFulfillmentOrderBatchCancellationRequest, ordersCreateFulfillmentOrderCancellationRequest, ordersCreateFulfillmentOrderConfirmation, ordersCreateFulfillmentOrderConfirmationRequest, ordersCreateFulfillmentOrderReturnRequest, ordersCreateFulfillmentOrderShipment, ordersCreateOrder, ordersCreateOrderCancellation, ordersCreateOrderCancellationRequest, ordersCreateOrderRepayment, ordersCreateOrderShippingFeeRefund, ordersCreateReturn, ordersCreateTrackingValidation, ordersDeleteDeliveryAddress, ordersGetBackofficeFulfillmentOrder, ordersGetBackofficeOrder, ordersGetBackofficeReturn, ordersGetBackofficeShipment, ordersGetDeliveryAddress, ordersGetFulfillmentOrder, ordersGetFulfillmentOrderCounts, ordersGetFulfillmentOrderTrackingStatus, ordersGetOrder, ordersGetReceivedCancellationRequest, ordersGetReceivedOrdersAnnualSales, ordersGetReturn, ordersGetReturnImageUploadUrl, ordersGetShipment, ordersListBackofficeFulfillmentOrders, ordersListBackofficeOrders, ordersListBackofficeReturns, ordersListBackofficeShipments, ordersListBackofficeUserDeliveryAddresses, ordersListBuyerOrders, ordersListDeliveryAddresses, ordersListFulfillmentOrderBuyerDeliveryAddresses, ordersListMyFulfillmentOrders, ordersListMyOrders, ordersListMyReturns, ordersListOrders, ordersListReceivedCancellationRequests, ordersListReceivedFulfillmentOrders, ordersListReceivedOrders, ordersListReceivedReturns, ordersListReturns, ordersListUserDeliveryAddresses, ordersPatchCancellationRequestApproval, ordersPatchCancellationRequestRejection, ordersPatchFulfillmentOrderDelivery, ordersPatchReturnApproval, ordersPatchReturnRejection, ordersUpdateBackofficeFulfillmentOrderShipmentTracking, ordersUpdateBackofficeFulfillmentOrderShippingAddress, ordersUpdateDeliveryAddress, ordersUpdateFulfillmentOrderShipmentTracking, ordersUpdateFulfillmentOrderShippingAddress, paymentCreateAuthorize, paymentCreateBackofficeRefundForceProcess, paymentCreatePaymentMethod, paymentCreatePaymentMethodDefault, paymentCreatePaymentRefund, paymentDeletePaymentMethod, paymentGetBackofficePayment, paymentGetBackofficeRefund, paymentGetPaymentDetails, paymentGetPaymentMethod, paymentGetRefundStatus, paymentListBackofficePayments, paymentListBackofficeRefunds, paymentListPaymentMethods, paymentListPayments, platformConfigCreateAppUiSettingReset, platformConfigCreateBroadcastChatNotice, platformConfigCreateChatBannedWord, platformConfigCreateUiConfigPublish, platformConfigCreateUiConfigRevert, platformConfigDeleteChatBannedWord, platformConfigDeleteUiConfigDraft, platformConfigGetAppDownloadSettings, platformConfigGetAppSyncChanges, platformConfigGetAppUiSettings, platformConfigGetAppVersionPolicies, platformConfigGetBoltbMarketSectionAllowedCategories, platformConfigGetBroadcastChatNotices, platformConfigGetBroadcastChatNoticeSettings, platformConfigGetCommissionConfig, platformConfigGetCompanyInfo, platformConfigGetFeeRates, platformConfigGetMobileRuntimePolicies, platformConfigGetPgFeeConfig, platformConfigGetPublicAppDownloadSettings, platformConfigGetPublicAppVersionPolicies, platformConfigGetPublicBoltbMarketSectionAllowedCategories, platformConfigGetPublicBroadcastChatNoticeSettings, platformConfigGetPublicCompanyInfo, platformConfigGetPublicMobileRuntimePolicy, platformConfigGetPublicPage, platformConfigGetPublicUiConfigManifest, platformConfigGetPublicUiConfigVersion, platformConfigGetSettlementConfig, platformConfigGetUiConfigFile, platformConfigListChatBannedWords, platformConfigListUiConfigFiles, platformConfigUpdateAppDownloadSettings, platformConfigUpdateAppUiSettings, platformConfigUpdateAppVersionPolicy, platformConfigUpdateBoltbMarketSectionAllowedCategories, platformConfigUpdateBroadcastChatNotice, platformConfigUpdateBroadcastChatNoticeOrder, platformConfigUpdateBroadcastChatNoticeSettings, platformConfigUpdateCommissionConfig, platformConfigUpdateCompanyInfo, platformConfigUpdateMobileRuntimePolicy, platformConfigUpdatePgFeeConfig, platformConfigUpdateSettlementConfig, platformConfigUpdateUiConfigDraft, platformConfigUpdateUiConfigSwitches, pointCreateBackofficeUserPointCredit, pointCreateBackofficeUserPointDebit, pointGetBackofficeUserPointBalance, pointGetMyPointBalance, pointListBackofficeUserPointTransactions, pointListMyPointTransactions, productCatalogCreateGroupBuy, productCatalogCreateGroupBuyActivation, productCatalogCreateGroupBuyBreak, productCatalogCreateGroupBuySlotRelease, productCatalogCreateGroupBuySlotReservation, productCatalogCreateProduct, productCatalogDeleteBackofficeProduct, productCatalogDeleteProduct, productCatalogGetBackofficeProduct, productCatalogGetGroupBuy, productCatalogGetProduct, productCatalogGetProductImageUploadUrl, productCatalogListBackofficeProducts, productCatalogListGroupBuys, productCatalogListProducts, productCatalogListProductsByBroadcast, productCatalogPatchBackofficeProductHideStatus, productCatalogPatchBackofficeProductUnhideStatus, productCatalogPatchProductArchiveStatus, productCatalogPatchProductHideStatus, productCatalogPatchProductPublishStatus, productCatalogPatchProductSalesChannel, productCatalogPatchProductUnhideStatus, productCatalogUpdateBackofficeProductCertification, productCatalogUpdateProductCategories, productCatalogUpdateProductDetails, productCatalogUpdateProductImages, productCatalogUpdateProductPricing, salesCreateAuction, salesCreateAuctionBid, salesCreateAuctionClose, salesCreateAuctionPriceReduction, salesCreateAuctionStart, salesCreateAuctionWinnerReveal, salesCreateAuctionWithProduct, salesCreateBackofficeAnonymousNicknameWord, salesCreateBackofficeAuctionCancel, salesCreateBackofficeInstantPurchaseEnd, salesCreateGiveaway, salesCreateGiveawayDraw, salesCreateGiveawayEntriesClose, salesCreateGiveawayEntry, salesCreateGiveawayWinnerAnnouncement, salesCreateGiveawayWithProduct, salesCreateGroupBuyBreakCompletion, salesCreateGroupBuyBreakStart, salesCreateGroupBuyCancellation, salesCreateGroupBuySales, salesCreateInstantPurchase, salesCreateInstantPurchaseEnd, salesCreateInstantPurchaseOrder, salesCreateInstantPurchaseWithProduct, salesCreateMarketplacePurchase, salesCreateSlotPaymentConfirmation, salesCreateSlotRelease, salesCreateSlotReservation, salesDeleteAuction, salesDeleteBackofficeAnonymousNicknameWord, salesGetAuction, salesGetBackofficeBroadcastSalesSettings, salesGetBroadcastProductCounts, salesGetDefaultProductName, salesGetGiveaway, salesGetGiveawayEntryTerms, salesGetGroupBuySales, salesGetInstantPurchase, salesListAuctions, salesListBackofficeAnonymousNicknameWords, salesListBids, salesListBroadcastSoldListings, salesListBroadcastUnsoldListings, salesListGiveaways, salesListGroupBuySales, salesListInstantPurchases, salesUpdateBackofficeBroadcastSalesSettings, salesUpdateInstantPurchaseQuantity, settlementCreateBackofficeSettlementBatchChangeStatus, settlementCreateBackofficeSettlementBatchCompletion, settlementCreateBackofficeSettlementBatchStartProcessing, settlementCreateBackofficeSettlementProcessCancel, settlementCreateBackofficeSettlementProcessComplete, settlementCreateBackofficeSettlementProcessStart, settlementCreateBackofficeSettlementReversal, settlementCreateSettlement, settlementCreateSettlementAccount, settlementCreateSettlementPayout, settlementCreateSettlementReport, settlementGetBackofficeSettlement, settlementGetSettlementAccount, settlementGetSettlementDetails, settlementListBackofficeSettlementExports, settlementListBackofficeSettlements, settlementListDealerOffsets, settlementListSettlements, settlementUpdatePaymentAgencyCallback, settlementUpdatePayoutFailed, settlementUpdatePayoutSuccess, socialNetworkCreateBackofficeLoungeCommentDeletion, socialNetworkCreateBackofficeLoungePostDeletion, socialNetworkCreateBackofficeLoungePostPin, socialNetworkCreateBackofficeLoungePostUnpin, socialNetworkCreateInvitation, socialNetworkCreateLoungeComment, socialNetworkCreateLoungeCommentLike, socialNetworkCreateLoungeCommentReply, socialNetworkCreateLoungePost, socialNetworkCreateLoungePostLike, socialNetworkCreateMyReferralLink, socialNetworkCreateReport, socialNetworkCreateReportReasonCategory, socialNetworkCreateUserBlock, socialNetworkCreateUserFollow, socialNetworkDeleteLoungeComment, socialNetworkDeleteLoungeCommentLike, socialNetworkDeleteLoungePost, socialNetworkDeleteLoungePostLike, socialNetworkDeleteReportReasonCategory, socialNetworkDeleteUserBlock, socialNetworkDeleteUserFollow, socialNetworkGetBackofficeLoungePost, socialNetworkGetLoungePost, socialNetworkGetLoungePostImageUploadUrl, socialNetworkGetMyReferralLink, socialNetworkGetMyReferralStats, socialNetworkGetPublicFollowerStats, socialNetworkGetPublicUserProfile, socialNetworkGetReport, socialNetworkGetReportReasonCategory, socialNetworkListActiveReportReasonCategories, socialNetworkListBackofficeLoungeCommentReplies, socialNetworkListBackofficeLoungePostComments, socialNetworkListBackofficeLoungePosts, socialNetworkListBackofficeUserBlockedUsers, socialNetworkListBlockedUsers, socialNetworkListFollowers, socialNetworkListFollowing, socialNetworkListInvitations, socialNetworkListLoungeCommentReplies, socialNetworkListLoungeComments, socialNetworkListLoungePosts, socialNetworkListMyLoungeComments, socialNetworkListMyReferredUsers, socialNetworkListReportReasonCategories, socialNetworkListReports, socialNetworkUpdateInvitation, socialNetworkUpdateLoungeComment, socialNetworkUpdateLoungePost, socialNetworkUpdateReport, socialNetworkUpdateReportReasonCategory, streamingCreateAgoraChannel, streamingCreateAgoraSessionHeartbeat, streamingCreateAgoraToken, streamingCreateBackofficeBroadcastForceEnd, streamingCreateBroadcast, streamingCreateBroadcastBuyerCall, streamingCreateBroadcastChatBan, streamingCreateBroadcastChatMessage, streamingCreateBroadcastEnd, streamingCreateBroadcastReminder, streamingCreateBroadcastStart, streamingCreateChatImage, streamingCreateLiveMemo, streamingCreateTestBroadcast, streamingDeleteAgoraSession, streamingDeleteBackofficeBroadcast, streamingDeleteBackofficeBroadcastChatMessage, streamingDeleteBroadcastReminder, streamingDeleteChatMessage, streamingDeleteLiveMemo, streamingDeleteScheduledBroadcast, streamingGetAdjacentBroadcasts, streamingGetBackofficeBroadcastHostPresenceSettings, streamingGetBackofficeBroadcastTelemetrySession, streamingGetBroadcast, streamingGetBroadcastBuyerPresences, streamingGetBroadcastReminder, streamingGetBroadcastSalesSummary, streamingGetBroadcastScreenState, streamingGetBroadcastThumbnailUploadUrl, streamingGetBroadcastViewerList, streamingGetChatHistory, streamingGetLiveMemoImageUploadUrl, streamingGetLiveMemos, streamingGetScheduledBroadcast, streamingGetUserChatContext, streamingListBackofficeBroadcastChatMessages, streamingListBackofficeBroadcasts, streamingListBackofficeUserBroadcastTelemetrySessions, streamingListDealerBroadcasts, streamingListFeaturedBroadcasts, streamingListLiveBroadcastCategoryIds, streamingListLiveBroadcasts, streamingListScheduledBroadcasts, streamingListTrendingBroadcasts, streamingUpdateAnnouncement, streamingUpdateBackofficeBroadcastHostPresenceSettings, streamingUpdateBroadcastConfig, streamingUpdateBroadcastTelemetrySession, streamingUpdateBroadcastTelemetryWindow, streamingUpdateLiveMemo, streamingUpdateScheduledBroadcast, streamingUpdateViewingMode, } from "../sdk.gen";
export const identityCreateUserMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityCreateUser({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityDeleteDealerProxyTokenMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityDeleteDealerProxyToken({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityCreateDealerProxyTokenMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityCreateDealerProxyToken({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityCreateUserSessionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityCreateUserSession({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityCreateUserTokenRefreshMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityCreateUserTokenRefresh({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
const createQueryKey = (id, options, infinite, tags) => {
    const params = {
        _id: id,
        baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl,
    };
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};
export const identityGetUserQueryKey = (options) => createQueryKey("identityGetUser", options);
export const identityGetUserOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await identityGetUser({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityGetUserQueryKey(options),
    });
};
export const identityUpdateProfileMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityUpdateProfile({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityGetProfileImageUploadUrlQueryKey = (options) => createQueryKey("identityGetProfileImageUploadUrl", options);
export const identityGetProfileImageUploadUrlOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await identityGetProfileImageUploadUrl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityGetProfileImageUploadUrlQueryKey(options),
    });
};
export const identityUpdateNotificationSettingsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityUpdateNotificationSettings({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityUpdatePhoneNumberMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityUpdatePhoneNumber({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityCreatePhoneVerificationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityCreatePhoneVerification({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityCreatePhoneVerificationCodeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityCreatePhoneVerificationCode({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityDeleteUserAccountMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityDeleteUserAccount({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityGetInterestCategoriesQueryKey = (options) => createQueryKey("identityGetInterestCategories", options);
export const identityGetInterestCategoriesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await identityGetInterestCategories({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityGetInterestCategoriesQueryKey(options),
    });
};
export const identityUpdateInterestCategoriesMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityUpdateInterestCategories({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identitySearchUsersQueryKey = (options) => createQueryKey("identitySearchUsers", options);
export const identitySearchUsersOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await identitySearchUsers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identitySearchUsersQueryKey(options),
    });
};
const createInfiniteParams = (queryKey, page) => {
    const params = {
        ...queryKey[0],
    };
    if (page.body) {
        params.body = {
            ...queryKey[0].body,
            ...page.body,
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers,
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path,
            ...page.path,
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query,
            ...page.query,
        };
    }
    return params;
};
export const identitySearchUsersInfiniteQueryKey = (options) => createQueryKey("identitySearchUsers", options, true);
export const identitySearchUsersInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await identitySearchUsers({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identitySearchUsersInfiniteQueryKey(options),
    });
};
export const identityCreateAdminSessionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityCreateAdminSession({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityCreateAdminTokenRefreshMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityCreateAdminTokenRefresh({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityCreateUserSuspensionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityCreateUserSuspension({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityListAdminAccountsQueryKey = (options) => createQueryKey("identityListAdminAccounts", options);
export const identityListAdminAccountsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await identityListAdminAccounts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityListAdminAccountsQueryKey(options),
    });
};
export const identityListAdminAccountsInfiniteQueryKey = (options) => createQueryKey("identityListAdminAccounts", options, true);
export const identityListAdminAccountsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await identityListAdminAccounts({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityListAdminAccountsInfiniteQueryKey(options),
    });
};
export const identityCreateAdminAccountMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityCreateAdminAccount({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityDeleteAdminAccountMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityDeleteAdminAccount({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityGetAdminAccountQueryKey = (options) => createQueryKey("identityGetAdminAccount", options);
export const identityGetAdminAccountOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await identityGetAdminAccount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityGetAdminAccountQueryKey(options),
    });
};
export const identityUpdateAdminAccountMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityUpdateAdminAccount({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityUpdateAdminPasswordMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityUpdateAdminPassword({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityListAdminLoginLocksQueryKey = (options) => createQueryKey("identityListAdminLoginLocks", options);
export const identityListAdminLoginLocksOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await identityListAdminLoginLocks({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityListAdminLoginLocksQueryKey(options),
    });
};
export const identityListAdminLoginLocksInfiniteQueryKey = (options) => createQueryKey("identityListAdminLoginLocks", options, true);
export const identityListAdminLoginLocksInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await identityListAdminLoginLocks({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityListAdminLoginLocksInfiniteQueryKey(options),
    });
};
export const identityCreateAdminLoginLockReleaseMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityCreateAdminLoginLockRelease({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityListUserAccountsQueryKey = (options) => createQueryKey("identityListUserAccounts", options);
export const identityListUserAccountsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await identityListUserAccounts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityListUserAccountsQueryKey(options),
    });
};
export const identityListUserAccountsInfiniteQueryKey = (options) => createQueryKey("identityListUserAccounts", options, true);
export const identityListUserAccountsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await identityListUserAccounts({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityListUserAccountsInfiniteQueryKey(options),
    });
};
export const identityGetBackofficeUserAccountQueryKey = (options) => createQueryKey("identityGetBackofficeUserAccount", options);
export const identityGetBackofficeUserAccountOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await identityGetBackofficeUserAccount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityGetBackofficeUserAccountQueryKey(options),
    });
};
export const identityCreateUserActivationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityCreateUserActivation({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityCreateBackofficeDealerProxySessionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityCreateBackofficeDealerProxySession({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityUpdateBackofficeUserProfileImageMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityUpdateBackofficeUserProfileImage({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityGetBackofficeProfileImageUploadUrlQueryKey = (options) => createQueryKey("identityGetBackofficeProfileImageUploadUrl", options);
export const identityGetBackofficeProfileImageUploadUrlOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await identityGetBackofficeProfileImageUploadUrl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityGetBackofficeProfileImageUploadUrlQueryKey(options),
    });
};
export const identityCreateBackofficeGrantDealerPermissionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityCreateBackofficeGrantDealerPermission({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityCreateBackofficeRevokeDealerPermissionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityCreateBackofficeRevokeDealerPermission({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityCreateBackofficeForceNicknameChangeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityCreateBackofficeForceNicknameChange({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityListBackofficeUserAdminMemosQueryKey = (options) => createQueryKey("identityListBackofficeUserAdminMemos", options);
export const identityListBackofficeUserAdminMemosOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await identityListBackofficeUserAdminMemos({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityListBackofficeUserAdminMemosQueryKey(options),
    });
};
export const identityListBackofficeUserAdminMemosInfiniteQueryKey = (options) => createQueryKey("identityListBackofficeUserAdminMemos", options, true);
export const identityListBackofficeUserAdminMemosInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await identityListBackofficeUserAdminMemos({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityListBackofficeUserAdminMemosInfiniteQueryKey(options),
    });
};
export const identityCreateBackofficeUserAdminMemoMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityCreateBackofficeUserAdminMemo({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityGetBackofficeNotificationSettingsSummaryQueryKey = (options) => createQueryKey("identityGetBackofficeNotificationSettingsSummary", options);
export const identityGetBackofficeNotificationSettingsSummaryOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await identityGetBackofficeNotificationSettingsSummary({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityGetBackofficeNotificationSettingsSummaryQueryKey(options),
    });
};
export const identityGetBackofficeAppVersionSummaryQueryKey = (options) => createQueryKey("identityGetBackofficeAppVersionSummary", options);
export const identityGetBackofficeAppVersionSummaryOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await identityGetBackofficeAppVersionSummary({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityGetBackofficeAppVersionSummaryQueryKey(options),
    });
};
export const identityListBackofficeUserHistoriesQueryKey = (options) => createQueryKey("identityListBackofficeUserHistories", options);
export const identityListBackofficeUserHistoriesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await identityListBackofficeUserHistories({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityListBackofficeUserHistoriesQueryKey(options),
    });
};
export const identityListBackofficeUserHistoriesInfiniteQueryKey = (options) => createQueryKey("identityListBackofficeUserHistories", options, true);
export const identityListBackofficeUserHistoriesInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await identityListBackofficeUserHistories({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityListBackofficeUserHistoriesInfiniteQueryKey(options),
    });
};
export const identityListAdminHistoriesQueryKey = (options) => createQueryKey("identityListAdminHistories", options);
export const identityListAdminHistoriesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await identityListAdminHistories({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityListAdminHistoriesQueryKey(options),
    });
};
export const identityListAdminHistoriesInfiniteQueryKey = (options) => createQueryKey("identityListAdminHistories", options, true);
export const identityListAdminHistoriesInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await identityListAdminHistories({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityListAdminHistoriesInfiniteQueryKey(options),
    });
};
export const identityListDealerHistoriesQueryKey = (options) => createQueryKey("identityListDealerHistories", options);
export const identityListDealerHistoriesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await identityListDealerHistories({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityListDealerHistoriesQueryKey(options),
    });
};
export const identityListDealerHistoriesInfiniteQueryKey = (options) => createQueryKey("identityListDealerHistories", options, true);
export const identityListDealerHistoriesInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await identityListDealerHistories({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityListDealerHistoriesInfiniteQueryKey(options),
    });
};
export const identityGetBackofficeUserInterestCategoriesQueryKey = (options) => createQueryKey("identityGetBackofficeUserInterestCategories", options);
export const identityGetBackofficeUserInterestCategoriesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await identityGetBackofficeUserInterestCategories({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityGetBackofficeUserInterestCategoriesQueryKey(options),
    });
};
export const identityUpdateBackofficeUserInterestCategoriesMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityUpdateBackofficeUserInterestCategories({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityCreateBackofficeInterestCategoryRepromptRequestMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityCreateBackofficeInterestCategoryRepromptRequest({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityCreateBackofficeDatabaseResetMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityCreateBackofficeDatabaseReset({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityCreateKakaoSessionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityCreateKakaoSession({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityCreateNaverTokenMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityCreateNaverToken({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityCreateSocialSessionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityCreateSocialSession({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityCreateSocialSignupMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityCreateSocialSignup({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityDeleteDeviceTokenMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityDeleteDeviceToken({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityCreateDeviceTokenMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityCreateDeviceToken({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const streamingListBackofficeUserBroadcastTelemetrySessionsQueryKey = (options) => createQueryKey("streamingListBackofficeUserBroadcastTelemetrySessions", options);
export const streamingListBackofficeUserBroadcastTelemetrySessionsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamingListBackofficeUserBroadcastTelemetrySessions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: streamingListBackofficeUserBroadcastTelemetrySessionsQueryKey(options),
    });
};
export const streamingListBackofficeUserBroadcastTelemetrySessionsInfiniteQueryKey = (options) => createQueryKey("streamingListBackofficeUserBroadcastTelemetrySessions", options, true);
export const streamingListBackofficeUserBroadcastTelemetrySessionsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await streamingListBackofficeUserBroadcastTelemetrySessions({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: streamingListBackofficeUserBroadcastTelemetrySessionsInfiniteQueryKey(options),
    });
};
export const identityUpdateAppInstallationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await identityUpdateAppInstallation({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ordersListOrdersQueryKey = (options) => createQueryKey("ordersListOrders", options);
export const ordersListOrdersOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ordersListOrders({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersListOrdersQueryKey(options),
    });
};
export const ordersListOrdersInfiniteQueryKey = (options) => createQueryKey("ordersListOrders", options, true);
export const ordersListOrdersInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await ordersListOrders({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersListOrdersInfiniteQueryKey(options),
    });
};
export const ordersCreateOrderMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersCreateOrder({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ordersCreateOrderCancellationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersCreateOrderCancellation({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ordersGetOrderQueryKey = (options) => createQueryKey("ordersGetOrder", options);
export const ordersGetOrderOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ordersGetOrder({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersGetOrderQueryKey(options),
    });
};
export const ordersCreateOrderRepaymentMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersCreateOrderRepayment({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ordersCreateOrderShippingFeeRefundMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersCreateOrderShippingFeeRefund({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ordersCreateFulfillmentOrderConfirmationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersCreateFulfillmentOrderConfirmation({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ordersPatchFulfillmentOrderDeliveryMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersPatchFulfillmentOrderDelivery({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ordersCreateFulfillmentOrderConfirmationRequestMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersCreateFulfillmentOrderConfirmationRequest({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ordersGetFulfillmentOrderQueryKey = (options) => createQueryKey("ordersGetFulfillmentOrder", options);
export const ordersGetFulfillmentOrderOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ordersGetFulfillmentOrder({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersGetFulfillmentOrderQueryKey(options),
    });
};
export const ordersListMyFulfillmentOrdersQueryKey = (options) => createQueryKey("ordersListMyFulfillmentOrders", options);
export const ordersListMyFulfillmentOrdersOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ordersListMyFulfillmentOrders({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersListMyFulfillmentOrdersQueryKey(options),
    });
};
export const ordersListMyFulfillmentOrdersInfiniteQueryKey = (options) => createQueryKey("ordersListMyFulfillmentOrders", options, true);
export const ordersListMyFulfillmentOrdersInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await ordersListMyFulfillmentOrders({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersListMyFulfillmentOrdersInfiniteQueryKey(options),
    });
};
export const ordersListReceivedFulfillmentOrdersQueryKey = (options) => createQueryKey("ordersListReceivedFulfillmentOrders", options);
export const ordersListReceivedFulfillmentOrdersOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ordersListReceivedFulfillmentOrders({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersListReceivedFulfillmentOrdersQueryKey(options),
    });
};
export const ordersListReceivedFulfillmentOrdersInfiniteQueryKey = (options) => createQueryKey("ordersListReceivedFulfillmentOrders", options, true);
export const ordersListReceivedFulfillmentOrdersInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await ordersListReceivedFulfillmentOrders({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersListReceivedFulfillmentOrdersInfiniteQueryKey(options),
    });
};
export const ordersGetFulfillmentOrderCountsQueryKey = (options) => createQueryKey("ordersGetFulfillmentOrderCounts", options);
export const ordersGetFulfillmentOrderCountsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ordersGetFulfillmentOrderCounts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersGetFulfillmentOrderCountsQueryKey(options),
    });
};
export const ordersListReturnsQueryKey = (options) => createQueryKey("ordersListReturns", options);
export const ordersListReturnsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ordersListReturns({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersListReturnsQueryKey(options),
    });
};
export const ordersCreateReturnMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersCreateReturn({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ordersGetReturnQueryKey = (options) => createQueryKey("ordersGetReturn", options);
export const ordersGetReturnOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ordersGetReturn({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersGetReturnQueryKey(options),
    });
};
export const ordersPatchReturnApprovalMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersPatchReturnApproval({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ordersPatchReturnRejectionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersPatchReturnRejection({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ordersGetReturnImageUploadUrlQueryKey = (options) => createQueryKey("ordersGetReturnImageUploadUrl", options);
export const ordersGetReturnImageUploadUrlOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ordersGetReturnImageUploadUrl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersGetReturnImageUploadUrlQueryKey(options),
    });
};
export const ordersListMyReturnsQueryKey = (options) => createQueryKey("ordersListMyReturns", options);
export const ordersListMyReturnsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ordersListMyReturns({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersListMyReturnsQueryKey(options),
    });
};
export const ordersListMyReturnsInfiniteQueryKey = (options) => createQueryKey("ordersListMyReturns", options, true);
export const ordersListMyReturnsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await ordersListMyReturns({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersListMyReturnsInfiniteQueryKey(options),
    });
};
export const ordersListReceivedReturnsQueryKey = (options) => createQueryKey("ordersListReceivedReturns", options);
export const ordersListReceivedReturnsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ordersListReceivedReturns({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersListReceivedReturnsQueryKey(options),
    });
};
export const ordersListReceivedReturnsInfiniteQueryKey = (options) => createQueryKey("ordersListReceivedReturns", options, true);
export const ordersListReceivedReturnsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await ordersListReceivedReturns({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersListReceivedReturnsInfiniteQueryKey(options),
    });
};
export const ordersGetShipmentQueryKey = (options) => createQueryKey("ordersGetShipment", options);
export const ordersGetShipmentOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ordersGetShipment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersGetShipmentQueryKey(options),
    });
};
export const ordersListDeliveryAddressesQueryKey = (options) => createQueryKey("ordersListDeliveryAddresses", options);
export const ordersListDeliveryAddressesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ordersListDeliveryAddresses({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersListDeliveryAddressesQueryKey(options),
    });
};
export const ordersListDeliveryAddressesInfiniteQueryKey = (options) => createQueryKey("ordersListDeliveryAddresses", options, true);
export const ordersListDeliveryAddressesInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await ordersListDeliveryAddresses({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersListDeliveryAddressesInfiniteQueryKey(options),
    });
};
export const ordersCreateDeliveryAddressMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersCreateDeliveryAddress({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ordersDeleteDeliveryAddressMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersDeleteDeliveryAddress({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ordersGetDeliveryAddressQueryKey = (options) => createQueryKey("ordersGetDeliveryAddress", options);
export const ordersGetDeliveryAddressOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ordersGetDeliveryAddress({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersGetDeliveryAddressQueryKey(options),
    });
};
export const ordersUpdateDeliveryAddressMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersUpdateDeliveryAddress({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ordersCreateDeliveryAddressDefaultMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersCreateDeliveryAddressDefault({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ordersListBuyerOrdersQueryKey = (options) => createQueryKey("ordersListBuyerOrders", options);
export const ordersListBuyerOrdersOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ordersListBuyerOrders({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersListBuyerOrdersQueryKey(options),
    });
};
export const ordersListBuyerOrdersInfiniteQueryKey = (options) => createQueryKey("ordersListBuyerOrders", options, true);
export const ordersListBuyerOrdersInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await ordersListBuyerOrders({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersListBuyerOrdersInfiniteQueryKey(options),
    });
};
export const ordersListUserDeliveryAddressesQueryKey = (options) => createQueryKey("ordersListUserDeliveryAddresses", options);
export const ordersListUserDeliveryAddressesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ordersListUserDeliveryAddresses({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersListUserDeliveryAddressesQueryKey(options),
    });
};
export const ordersListMyOrdersQueryKey = (options) => createQueryKey("ordersListMyOrders", options);
export const ordersListMyOrdersOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ordersListMyOrders({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersListMyOrdersQueryKey(options),
    });
};
export const ordersListMyOrdersInfiniteQueryKey = (options) => createQueryKey("ordersListMyOrders", options, true);
export const ordersListMyOrdersInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await ordersListMyOrders({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersListMyOrdersInfiniteQueryKey(options),
    });
};
export const ordersListReceivedOrdersQueryKey = (options) => createQueryKey("ordersListReceivedOrders", options);
export const ordersListReceivedOrdersOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ordersListReceivedOrders({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersListReceivedOrdersQueryKey(options),
    });
};
export const ordersListReceivedOrdersInfiniteQueryKey = (options) => createQueryKey("ordersListReceivedOrders", options, true);
export const ordersListReceivedOrdersInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await ordersListReceivedOrders({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersListReceivedOrdersInfiniteQueryKey(options),
    });
};
export const ordersGetReceivedOrdersAnnualSalesQueryKey = (options) => createQueryKey("ordersGetReceivedOrdersAnnualSales", options);
export const ordersGetReceivedOrdersAnnualSalesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ordersGetReceivedOrdersAnnualSales({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersGetReceivedOrdersAnnualSalesQueryKey(options),
    });
};
export const ordersListBackofficeOrdersQueryKey = (options) => createQueryKey("ordersListBackofficeOrders", options);
export const ordersListBackofficeOrdersOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ordersListBackofficeOrders({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersListBackofficeOrdersQueryKey(options),
    });
};
export const ordersListBackofficeOrdersInfiniteQueryKey = (options) => createQueryKey("ordersListBackofficeOrders", options, true);
export const ordersListBackofficeOrdersInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await ordersListBackofficeOrders({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersListBackofficeOrdersInfiniteQueryKey(options),
    });
};
export const ordersGetBackofficeOrderQueryKey = (options) => createQueryKey("ordersGetBackofficeOrder", options);
export const ordersGetBackofficeOrderOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ordersGetBackofficeOrder({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersGetBackofficeOrderQueryKey(options),
    });
};
export const ordersCreateBackofficeOrderForceCancelRefundMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersCreateBackofficeOrderForceCancelRefund({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ordersCreateBackofficeOrderShippingFeeRefundMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersCreateBackofficeOrderShippingFeeRefund({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ordersListBackofficeUserDeliveryAddressesQueryKey = (options) => createQueryKey("ordersListBackofficeUserDeliveryAddresses", options);
export const ordersListBackofficeUserDeliveryAddressesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ordersListBackofficeUserDeliveryAddresses({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersListBackofficeUserDeliveryAddressesQueryKey(options),
    });
};
export const ordersListBackofficeUserDeliveryAddressesInfiniteQueryKey = (options) => createQueryKey("ordersListBackofficeUserDeliveryAddresses", options, true);
export const ordersListBackofficeUserDeliveryAddressesInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await ordersListBackofficeUserDeliveryAddresses({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersListBackofficeUserDeliveryAddressesInfiniteQueryKey(options),
    });
};
export const ordersListBackofficeReturnsQueryKey = (options) => createQueryKey("ordersListBackofficeReturns", options);
export const ordersListBackofficeReturnsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ordersListBackofficeReturns({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersListBackofficeReturnsQueryKey(options),
    });
};
export const ordersListBackofficeReturnsInfiniteQueryKey = (options) => createQueryKey("ordersListBackofficeReturns", options, true);
export const ordersListBackofficeReturnsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await ordersListBackofficeReturns({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersListBackofficeReturnsInfiniteQueryKey(options),
    });
};
export const ordersGetBackofficeReturnQueryKey = (options) => createQueryKey("ordersGetBackofficeReturn", options);
export const ordersGetBackofficeReturnOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ordersGetBackofficeReturn({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersGetBackofficeReturnQueryKey(options),
    });
};
export const ordersCreateBackofficeReturnForceApproveRefundMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersCreateBackofficeReturnForceApproveRefund({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ordersListBackofficeShipmentsQueryKey = (options) => createQueryKey("ordersListBackofficeShipments", options);
export const ordersListBackofficeShipmentsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ordersListBackofficeShipments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersListBackofficeShipmentsQueryKey(options),
    });
};
export const ordersListBackofficeShipmentsInfiniteQueryKey = (options) => createQueryKey("ordersListBackofficeShipments", options, true);
export const ordersListBackofficeShipmentsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await ordersListBackofficeShipments({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersListBackofficeShipmentsInfiniteQueryKey(options),
    });
};
export const ordersGetBackofficeShipmentQueryKey = (options) => createQueryKey("ordersGetBackofficeShipment", options);
export const ordersGetBackofficeShipmentOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ordersGetBackofficeShipment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersGetBackofficeShipmentQueryKey(options),
    });
};
export const ordersListBackofficeFulfillmentOrdersQueryKey = (options) => createQueryKey("ordersListBackofficeFulfillmentOrders", options);
export const ordersListBackofficeFulfillmentOrdersOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ordersListBackofficeFulfillmentOrders({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersListBackofficeFulfillmentOrdersQueryKey(options),
    });
};
export const ordersListBackofficeFulfillmentOrdersInfiniteQueryKey = (options) => createQueryKey("ordersListBackofficeFulfillmentOrders", options, true);
export const ordersListBackofficeFulfillmentOrdersInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await ordersListBackofficeFulfillmentOrders({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersListBackofficeFulfillmentOrdersInfiniteQueryKey(options),
    });
};
export const ordersGetBackofficeFulfillmentOrderQueryKey = (options) => createQueryKey("ordersGetBackofficeFulfillmentOrder", options);
export const ordersGetBackofficeFulfillmentOrderOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ordersGetBackofficeFulfillmentOrder({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersGetBackofficeFulfillmentOrderQueryKey(options),
    });
};
export const ordersCreateBackofficeFulfillmentOrderForceCancelRefundMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersCreateBackofficeFulfillmentOrderForceCancelRefund({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ordersUpdateBackofficeFulfillmentOrderShipmentTrackingMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersUpdateBackofficeFulfillmentOrderShipmentTracking({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ordersUpdateBackofficeFulfillmentOrderShippingAddressMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersUpdateBackofficeFulfillmentOrderShippingAddress({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ordersCreateFulfillmentOrderShipmentMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersCreateFulfillmentOrderShipment({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ordersUpdateFulfillmentOrderShippingAddressMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersUpdateFulfillmentOrderShippingAddress({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ordersListFulfillmentOrderBuyerDeliveryAddressesQueryKey = (options) => createQueryKey("ordersListFulfillmentOrderBuyerDeliveryAddresses", options);
export const ordersListFulfillmentOrderBuyerDeliveryAddressesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ordersListFulfillmentOrderBuyerDeliveryAddresses({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersListFulfillmentOrderBuyerDeliveryAddressesQueryKey(options),
    });
};
export const ordersGetFulfillmentOrderTrackingStatusQueryKey = (options) => createQueryKey("ordersGetFulfillmentOrderTrackingStatus", options);
export const ordersGetFulfillmentOrderTrackingStatusOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ordersGetFulfillmentOrderTrackingStatus({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersGetFulfillmentOrderTrackingStatusQueryKey(options),
    });
};
export const ordersUpdateFulfillmentOrderShipmentTrackingMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersUpdateFulfillmentOrderShipmentTracking({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ordersCreateTrackingValidationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersCreateTrackingValidation({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ordersCreateOrderCancellationRequestMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersCreateOrderCancellationRequest({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ordersCreateFulfillmentOrderCancellationRequestMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersCreateFulfillmentOrderCancellationRequest({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ordersCreateFulfillmentOrderBatchCancellationRequestMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersCreateFulfillmentOrderBatchCancellationRequest({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ordersCreateFulfillmentOrderReturnRequestMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersCreateFulfillmentOrderReturnRequest({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ordersGetReceivedCancellationRequestQueryKey = (options) => createQueryKey("ordersGetReceivedCancellationRequest", options);
export const ordersGetReceivedCancellationRequestOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ordersGetReceivedCancellationRequest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersGetReceivedCancellationRequestQueryKey(options),
    });
};
export const ordersPatchCancellationRequestApprovalMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersPatchCancellationRequestApproval({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ordersPatchCancellationRequestRejectionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersPatchCancellationRequestRejection({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ordersListReceivedCancellationRequestsQueryKey = (options) => createQueryKey("ordersListReceivedCancellationRequests", options);
export const ordersListReceivedCancellationRequestsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ordersListReceivedCancellationRequests({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersListReceivedCancellationRequestsQueryKey(options),
    });
};
export const ordersListReceivedCancellationRequestsInfiniteQueryKey = (options) => createQueryKey("ordersListReceivedCancellationRequests", options, true);
export const ordersListReceivedCancellationRequestsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await ordersListReceivedCancellationRequests({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ordersListReceivedCancellationRequestsInfiniteQueryKey(options),
    });
};
export const ordersCreateCancellationRequestBatchApprovalMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ordersCreateCancellationRequestBatchApproval({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const paymentListPaymentsQueryKey = (options) => createQueryKey("paymentListPayments", options);
export const paymentListPaymentsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await paymentListPayments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: paymentListPaymentsQueryKey(options),
    });
};
export const paymentListPaymentsInfiniteQueryKey = (options) => createQueryKey("paymentListPayments", options, true);
export const paymentListPaymentsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await paymentListPayments({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: paymentListPaymentsInfiniteQueryKey(options),
    });
};
export const paymentGetPaymentDetailsQueryKey = (options) => createQueryKey("paymentGetPaymentDetails", options);
export const paymentGetPaymentDetailsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await paymentGetPaymentDetails({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: paymentGetPaymentDetailsQueryKey(options),
    });
};
export const paymentCreatePaymentRefundMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await paymentCreatePaymentRefund({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const paymentGetRefundStatusQueryKey = (options) => createQueryKey("paymentGetRefundStatus", options);
export const paymentGetRefundStatusOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await paymentGetRefundStatus({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: paymentGetRefundStatusQueryKey(options),
    });
};
export const paymentListPaymentMethodsQueryKey = (options) => createQueryKey("paymentListPaymentMethods", options);
export const paymentListPaymentMethodsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await paymentListPaymentMethods({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: paymentListPaymentMethodsQueryKey(options),
    });
};
export const paymentListPaymentMethodsInfiniteQueryKey = (options) => createQueryKey("paymentListPaymentMethods", options, true);
export const paymentListPaymentMethodsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await paymentListPaymentMethods({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: paymentListPaymentMethodsInfiniteQueryKey(options),
    });
};
export const paymentCreatePaymentMethodMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await paymentCreatePaymentMethod({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const paymentDeletePaymentMethodMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await paymentDeletePaymentMethod({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const paymentGetPaymentMethodQueryKey = (options) => createQueryKey("paymentGetPaymentMethod", options);
export const paymentGetPaymentMethodOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await paymentGetPaymentMethod({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: paymentGetPaymentMethodQueryKey(options),
    });
};
export const paymentCreatePaymentMethodDefaultMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await paymentCreatePaymentMethodDefault({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const paymentCreateAuthorizeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await paymentCreateAuthorize({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const paymentListBackofficePaymentsQueryKey = (options) => createQueryKey("paymentListBackofficePayments", options);
export const paymentListBackofficePaymentsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await paymentListBackofficePayments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: paymentListBackofficePaymentsQueryKey(options),
    });
};
export const paymentListBackofficePaymentsInfiniteQueryKey = (options) => createQueryKey("paymentListBackofficePayments", options, true);
export const paymentListBackofficePaymentsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await paymentListBackofficePayments({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: paymentListBackofficePaymentsInfiniteQueryKey(options),
    });
};
export const paymentGetBackofficePaymentQueryKey = (options) => createQueryKey("paymentGetBackofficePayment", options);
export const paymentGetBackofficePaymentOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await paymentGetBackofficePayment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: paymentGetBackofficePaymentQueryKey(options),
    });
};
export const paymentListBackofficeRefundsQueryKey = (options) => createQueryKey("paymentListBackofficeRefunds", options);
export const paymentListBackofficeRefundsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await paymentListBackofficeRefunds({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: paymentListBackofficeRefundsQueryKey(options),
    });
};
export const paymentListBackofficeRefundsInfiniteQueryKey = (options) => createQueryKey("paymentListBackofficeRefunds", options, true);
export const paymentListBackofficeRefundsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await paymentListBackofficeRefunds({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: paymentListBackofficeRefundsInfiniteQueryKey(options),
    });
};
export const paymentGetBackofficeRefundQueryKey = (options) => createQueryKey("paymentGetBackofficeRefund", options);
export const paymentGetBackofficeRefundOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await paymentGetBackofficeRefund({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: paymentGetBackofficeRefundQueryKey(options),
    });
};
export const paymentCreateBackofficeRefundForceProcessMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await paymentCreateBackofficeRefundForceProcess({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const productCatalogListProductsQueryKey = (options) => createQueryKey("productCatalogListProducts", options);
export const productCatalogListProductsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await productCatalogListProducts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: productCatalogListProductsQueryKey(options),
    });
};
export const productCatalogListProductsInfiniteQueryKey = (options) => createQueryKey("productCatalogListProducts", options, true);
export const productCatalogListProductsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await productCatalogListProducts({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: productCatalogListProductsInfiniteQueryKey(options),
    });
};
export const productCatalogCreateProductMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await productCatalogCreateProduct({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const productCatalogDeleteProductMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await productCatalogDeleteProduct({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const productCatalogGetProductQueryKey = (options) => createQueryKey("productCatalogGetProduct", options);
export const productCatalogGetProductOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await productCatalogGetProduct({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: productCatalogGetProductQueryKey(options),
    });
};
export const productCatalogUpdateProductDetailsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await productCatalogUpdateProductDetails({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const productCatalogUpdateProductImagesMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await productCatalogUpdateProductImages({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const productCatalogUpdateProductPricingMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await productCatalogUpdateProductPricing({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const productCatalogPatchProductPublishStatusMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await productCatalogPatchProductPublishStatus({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const productCatalogGetProductImageUploadUrlQueryKey = (options) => createQueryKey("productCatalogGetProductImageUploadUrl", options);
export const productCatalogGetProductImageUploadUrlOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await productCatalogGetProductImageUploadUrl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: productCatalogGetProductImageUploadUrlQueryKey(options),
    });
};
export const productCatalogPatchProductArchiveStatusMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await productCatalogPatchProductArchiveStatus({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const productCatalogPatchProductHideStatusMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await productCatalogPatchProductHideStatus({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const productCatalogPatchProductUnhideStatusMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await productCatalogPatchProductUnhideStatus({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const productCatalogUpdateProductCategoriesMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await productCatalogUpdateProductCategories({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const productCatalogPatchProductSalesChannelMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await productCatalogPatchProductSalesChannel({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const productCatalogCreateGroupBuyMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await productCatalogCreateGroupBuy({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const productCatalogListProductsByBroadcastQueryKey = (options) => createQueryKey("productCatalogListProductsByBroadcast", options);
export const productCatalogListProductsByBroadcastOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await productCatalogListProductsByBroadcast({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: productCatalogListProductsByBroadcastQueryKey(options),
    });
};
export const productCatalogListGroupBuysQueryKey = (options) => createQueryKey("productCatalogListGroupBuys", options);
export const productCatalogListGroupBuysOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await productCatalogListGroupBuys({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: productCatalogListGroupBuysQueryKey(options),
    });
};
export const productCatalogListGroupBuysInfiniteQueryKey = (options) => createQueryKey("productCatalogListGroupBuys", options, true);
export const productCatalogListGroupBuysInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await productCatalogListGroupBuys({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: productCatalogListGroupBuysInfiniteQueryKey(options),
    });
};
export const productCatalogGetGroupBuyQueryKey = (options) => createQueryKey("productCatalogGetGroupBuy", options);
export const productCatalogGetGroupBuyOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await productCatalogGetGroupBuy({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: productCatalogGetGroupBuyQueryKey(options),
    });
};
export const productCatalogCreateGroupBuySlotReservationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await productCatalogCreateGroupBuySlotReservation({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const productCatalogCreateGroupBuySlotReleaseMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await productCatalogCreateGroupBuySlotRelease({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const productCatalogCreateGroupBuyBreakMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await productCatalogCreateGroupBuyBreak({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const productCatalogCreateGroupBuyActivationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await productCatalogCreateGroupBuyActivation({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const productCatalogListBackofficeProductsQueryKey = (options) => createQueryKey("productCatalogListBackofficeProducts", options);
export const productCatalogListBackofficeProductsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await productCatalogListBackofficeProducts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: productCatalogListBackofficeProductsQueryKey(options),
    });
};
export const productCatalogListBackofficeProductsInfiniteQueryKey = (options) => createQueryKey("productCatalogListBackofficeProducts", options, true);
export const productCatalogListBackofficeProductsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await productCatalogListBackofficeProducts({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: productCatalogListBackofficeProductsInfiniteQueryKey(options),
    });
};
export const productCatalogDeleteBackofficeProductMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await productCatalogDeleteBackofficeProduct({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const productCatalogGetBackofficeProductQueryKey = (options) => createQueryKey("productCatalogGetBackofficeProduct", options);
export const productCatalogGetBackofficeProductOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await productCatalogGetBackofficeProduct({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: productCatalogGetBackofficeProductQueryKey(options),
    });
};
export const productCatalogPatchBackofficeProductHideStatusMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await productCatalogPatchBackofficeProductHideStatus({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const productCatalogPatchBackofficeProductUnhideStatusMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await productCatalogPatchBackofficeProductUnhideStatus({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const productCatalogUpdateBackofficeProductCertificationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await productCatalogUpdateBackofficeProductCertification({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const salesListAuctionsQueryKey = (options) => createQueryKey("salesListAuctions", options);
export const salesListAuctionsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await salesListAuctions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: salesListAuctionsQueryKey(options),
    });
};
export const salesListAuctionsInfiniteQueryKey = (options) => createQueryKey("salesListAuctions", options, true);
export const salesListAuctionsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await salesListAuctions({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: salesListAuctionsInfiniteQueryKey(options),
    });
};
export const salesCreateAuctionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesCreateAuction({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const salesCreateAuctionWithProductMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesCreateAuctionWithProduct({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const salesDeleteAuctionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesDeleteAuction({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const salesGetAuctionQueryKey = (options) => createQueryKey("salesGetAuction", options);
export const salesGetAuctionOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await salesGetAuction({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: salesGetAuctionQueryKey(options),
    });
};
export const salesCreateAuctionStartMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesCreateAuctionStart({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const salesListBidsQueryKey = (options) => createQueryKey("salesListBids", options);
export const salesListBidsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await salesListBids({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: salesListBidsQueryKey(options),
    });
};
export const salesListBidsInfiniteQueryKey = (options) => createQueryKey("salesListBids", options, true);
export const salesListBidsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await salesListBids({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: salesListBidsInfiniteQueryKey(options),
    });
};
export const salesCreateAuctionBidMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesCreateAuctionBid({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const salesCreateAuctionCloseMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesCreateAuctionClose({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const salesCreateAuctionWinnerRevealMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesCreateAuctionWinnerReveal({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const salesCreateAuctionPriceReductionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesCreateAuctionPriceReduction({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const salesListInstantPurchasesQueryKey = (options) => createQueryKey("salesListInstantPurchases", options);
export const salesListInstantPurchasesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await salesListInstantPurchases({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: salesListInstantPurchasesQueryKey(options),
    });
};
export const salesListInstantPurchasesInfiniteQueryKey = (options) => createQueryKey("salesListInstantPurchases", options, true);
export const salesListInstantPurchasesInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await salesListInstantPurchases({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: salesListInstantPurchasesInfiniteQueryKey(options),
    });
};
export const salesCreateInstantPurchaseMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesCreateInstantPurchase({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const salesCreateInstantPurchaseWithProductMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesCreateInstantPurchaseWithProduct({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const salesGetInstantPurchaseQueryKey = (options) => createQueryKey("salesGetInstantPurchase", options);
export const salesGetInstantPurchaseOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await salesGetInstantPurchase({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: salesGetInstantPurchaseQueryKey(options),
    });
};
export const salesCreateInstantPurchaseOrderMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesCreateInstantPurchaseOrder({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const salesCreateInstantPurchaseEndMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesCreateInstantPurchaseEnd({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const salesUpdateInstantPurchaseQuantityMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesUpdateInstantPurchaseQuantity({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const salesCreateBackofficeInstantPurchaseEndMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesCreateBackofficeInstantPurchaseEnd({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const salesCreateBackofficeAuctionCancelMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesCreateBackofficeAuctionCancel({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const salesGetBackofficeBroadcastSalesSettingsQueryKey = (options) => createQueryKey("salesGetBackofficeBroadcastSalesSettings", options);
export const salesGetBackofficeBroadcastSalesSettingsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await salesGetBackofficeBroadcastSalesSettings({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: salesGetBackofficeBroadcastSalesSettingsQueryKey(options),
    });
};
export const salesUpdateBackofficeBroadcastSalesSettingsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesUpdateBackofficeBroadcastSalesSettings({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const streamingGetBackofficeBroadcastHostPresenceSettingsQueryKey = (options) => createQueryKey("streamingGetBackofficeBroadcastHostPresenceSettings", options);
export const streamingGetBackofficeBroadcastHostPresenceSettingsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamingGetBackofficeBroadcastHostPresenceSettings({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: streamingGetBackofficeBroadcastHostPresenceSettingsQueryKey(options),
    });
};
export const streamingUpdateBackofficeBroadcastHostPresenceSettingsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await streamingUpdateBackofficeBroadcastHostPresenceSettings({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const salesListBackofficeAnonymousNicknameWordsQueryKey = (options) => createQueryKey("salesListBackofficeAnonymousNicknameWords", options);
export const salesListBackofficeAnonymousNicknameWordsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await salesListBackofficeAnonymousNicknameWords({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: salesListBackofficeAnonymousNicknameWordsQueryKey(options),
    });
};
export const salesCreateBackofficeAnonymousNicknameWordMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesCreateBackofficeAnonymousNicknameWord({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const salesDeleteBackofficeAnonymousNicknameWordMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesDeleteBackofficeAnonymousNicknameWord({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const salesListGroupBuySalesQueryKey = (options) => createQueryKey("salesListGroupBuySales", options);
export const salesListGroupBuySalesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await salesListGroupBuySales({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: salesListGroupBuySalesQueryKey(options),
    });
};
export const salesListGroupBuySalesInfiniteQueryKey = (options) => createQueryKey("salesListGroupBuySales", options, true);
export const salesListGroupBuySalesInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await salesListGroupBuySales({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: salesListGroupBuySalesInfiniteQueryKey(options),
    });
};
export const salesCreateGroupBuySalesMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesCreateGroupBuySales({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const salesGetGroupBuySalesQueryKey = (options) => createQueryKey("salesGetGroupBuySales", options);
export const salesGetGroupBuySalesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await salesGetGroupBuySales({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: salesGetGroupBuySalesQueryKey(options),
    });
};
export const salesCreateSlotReservationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesCreateSlotReservation({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const salesCreateGroupBuyBreakStartMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesCreateGroupBuyBreakStart({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const salesCreateGroupBuyBreakCompletionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesCreateGroupBuyBreakCompletion({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const salesCreateGroupBuyCancellationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesCreateGroupBuyCancellation({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const salesCreateSlotReleaseMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesCreateSlotRelease({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const salesCreateSlotPaymentConfirmationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesCreateSlotPaymentConfirmation({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const salesListGiveawaysQueryKey = (options) => createQueryKey("salesListGiveaways", options);
export const salesListGiveawaysOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await salesListGiveaways({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: salesListGiveawaysQueryKey(options),
    });
};
export const salesListGiveawaysInfiniteQueryKey = (options) => createQueryKey("salesListGiveaways", options, true);
export const salesListGiveawaysInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await salesListGiveaways({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: salesListGiveawaysInfiniteQueryKey(options),
    });
};
export const salesCreateGiveawayMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesCreateGiveaway({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const salesCreateGiveawayWithProductMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesCreateGiveawayWithProduct({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const salesGetGiveawayQueryKey = (options) => createQueryKey("salesGetGiveaway", options);
export const salesGetGiveawayOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await salesGetGiveaway({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: salesGetGiveawayQueryKey(options),
    });
};
export const salesGetGiveawayEntryTermsQueryKey = (options) => createQueryKey("salesGetGiveawayEntryTerms", options);
export const salesGetGiveawayEntryTermsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await salesGetGiveawayEntryTerms({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: salesGetGiveawayEntryTermsQueryKey(options),
    });
};
export const salesCreateGiveawayEntryMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesCreateGiveawayEntry({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const salesCreateGiveawayDrawMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesCreateGiveawayDraw({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const salesCreateGiveawayEntriesCloseMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesCreateGiveawayEntriesClose({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const salesCreateGiveawayWinnerAnnouncementMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesCreateGiveawayWinnerAnnouncement({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const salesGetBroadcastProductCountsQueryKey = (options) => createQueryKey("salesGetBroadcastProductCounts", options);
export const salesGetBroadcastProductCountsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await salesGetBroadcastProductCounts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: salesGetBroadcastProductCountsQueryKey(options),
    });
};
export const salesGetDefaultProductNameQueryKey = (options) => createQueryKey("salesGetDefaultProductName", options);
export const salesGetDefaultProductNameOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await salesGetDefaultProductName({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: salesGetDefaultProductNameQueryKey(options),
    });
};
export const salesListBroadcastSoldListingsQueryKey = (options) => createQueryKey("salesListBroadcastSoldListings", options);
export const salesListBroadcastSoldListingsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await salesListBroadcastSoldListings({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: salesListBroadcastSoldListingsQueryKey(options),
    });
};
export const salesListBroadcastSoldListingsInfiniteQueryKey = (options) => createQueryKey("salesListBroadcastSoldListings", options, true);
export const salesListBroadcastSoldListingsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await salesListBroadcastSoldListings({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: salesListBroadcastSoldListingsInfiniteQueryKey(options),
    });
};
export const salesListBroadcastUnsoldListingsQueryKey = (options) => createQueryKey("salesListBroadcastUnsoldListings", options);
export const salesListBroadcastUnsoldListingsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await salesListBroadcastUnsoldListings({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: salesListBroadcastUnsoldListingsQueryKey(options),
    });
};
export const salesListBroadcastUnsoldListingsInfiniteQueryKey = (options) => createQueryKey("salesListBroadcastUnsoldListings", options, true);
export const salesListBroadcastUnsoldListingsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await salesListBroadcastUnsoldListings({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: salesListBroadcastUnsoldListingsInfiniteQueryKey(options),
    });
};
export const salesCreateMarketplacePurchaseMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesCreateMarketplacePurchase({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const streamingCreateBroadcastMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await streamingCreateBroadcast({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const streamingCreateTestBroadcastMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await streamingCreateTestBroadcast({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const streamingListLiveBroadcastsQueryKey = (options) => createQueryKey("streamingListLiveBroadcasts", options);
export const streamingListLiveBroadcastsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamingListLiveBroadcasts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: streamingListLiveBroadcastsQueryKey(options),
    });
};
export const streamingListLiveBroadcastsInfiniteQueryKey = (options) => createQueryKey("streamingListLiveBroadcasts", options, true);
export const streamingListLiveBroadcastsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await streamingListLiveBroadcasts({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: streamingListLiveBroadcastsInfiniteQueryKey(options),
    });
};
export const streamingListLiveBroadcastCategoryIdsQueryKey = (options) => createQueryKey("streamingListLiveBroadcastCategoryIds", options);
export const streamingListLiveBroadcastCategoryIdsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamingListLiveBroadcastCategoryIds({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: streamingListLiveBroadcastCategoryIdsQueryKey(options),
    });
};
export const streamingListScheduledBroadcastsQueryKey = (options) => createQueryKey("streamingListScheduledBroadcasts", options);
export const streamingListScheduledBroadcastsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamingListScheduledBroadcasts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: streamingListScheduledBroadcastsQueryKey(options),
    });
};
export const streamingListScheduledBroadcastsInfiniteQueryKey = (options) => createQueryKey("streamingListScheduledBroadcasts", options, true);
export const streamingListScheduledBroadcastsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await streamingListScheduledBroadcasts({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: streamingListScheduledBroadcastsInfiniteQueryKey(options),
    });
};
export const streamingDeleteScheduledBroadcastMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await streamingDeleteScheduledBroadcast({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const streamingGetScheduledBroadcastQueryKey = (options) => createQueryKey("streamingGetScheduledBroadcast", options);
export const streamingGetScheduledBroadcastOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamingGetScheduledBroadcast({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: streamingGetScheduledBroadcastQueryKey(options),
    });
};
export const streamingUpdateScheduledBroadcastMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await streamingUpdateScheduledBroadcast({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const streamingListTrendingBroadcastsQueryKey = (options) => createQueryKey("streamingListTrendingBroadcasts", options);
export const streamingListTrendingBroadcastsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamingListTrendingBroadcasts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: streamingListTrendingBroadcastsQueryKey(options),
    });
};
export const streamingListTrendingBroadcastsInfiniteQueryKey = (options) => createQueryKey("streamingListTrendingBroadcasts", options, true);
export const streamingListTrendingBroadcastsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await streamingListTrendingBroadcasts({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: streamingListTrendingBroadcastsInfiniteQueryKey(options),
    });
};
export const streamingListFeaturedBroadcastsQueryKey = (options) => createQueryKey("streamingListFeaturedBroadcasts", options);
export const streamingListFeaturedBroadcastsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamingListFeaturedBroadcasts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: streamingListFeaturedBroadcastsQueryKey(options),
    });
};
export const streamingListFeaturedBroadcastsInfiniteQueryKey = (options) => createQueryKey("streamingListFeaturedBroadcasts", options, true);
export const streamingListFeaturedBroadcastsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await streamingListFeaturedBroadcasts({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: streamingListFeaturedBroadcastsInfiniteQueryKey(options),
    });
};
export const streamingGetBroadcastQueryKey = (options) => createQueryKey("streamingGetBroadcast", options);
export const streamingGetBroadcastOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamingGetBroadcast({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: streamingGetBroadcastQueryKey(options),
    });
};
export const streamingCreateBroadcastStartMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await streamingCreateBroadcastStart({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const streamingCreateBroadcastEndMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await streamingCreateBroadcastEnd({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const streamingUpdateBroadcastTelemetrySessionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await streamingUpdateBroadcastTelemetrySession({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const streamingUpdateBroadcastTelemetryWindowMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await streamingUpdateBroadcastTelemetryWindow({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const streamingGetBackofficeBroadcastTelemetrySessionQueryKey = (options) => createQueryKey("streamingGetBackofficeBroadcastTelemetrySession", options);
export const streamingGetBackofficeBroadcastTelemetrySessionOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamingGetBackofficeBroadcastTelemetrySession({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: streamingGetBackofficeBroadcastTelemetrySessionQueryKey(options),
    });
};
export const streamingUpdateBroadcastConfigMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await streamingUpdateBroadcastConfig({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const streamingUpdateAnnouncementMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await streamingUpdateAnnouncement({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const streamingUpdateViewingModeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await streamingUpdateViewingMode({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const streamingGetChatHistoryQueryKey = (options) => createQueryKey("streamingGetChatHistory", options);
export const streamingGetChatHistoryOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamingGetChatHistory({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: streamingGetChatHistoryQueryKey(options),
    });
};
export const streamingGetChatHistoryInfiniteQueryKey = (options) => createQueryKey("streamingGetChatHistory", options, true);
export const streamingGetChatHistoryInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await streamingGetChatHistory({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: streamingGetChatHistoryInfiniteQueryKey(options),
    });
};
export const streamingCreateBroadcastChatMessageMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await streamingCreateBroadcastChatMessage({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const streamingCreateChatImageMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await streamingCreateChatImage({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const streamingDeleteChatMessageMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await streamingDeleteChatMessage({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const streamingCreateBroadcastChatBanMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await streamingCreateBroadcastChatBan({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const streamingGetUserChatContextQueryKey = (options) => createQueryKey("streamingGetUserChatContext", options);
export const streamingGetUserChatContextOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamingGetUserChatContext({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: streamingGetUserChatContextQueryKey(options),
    });
};
export const streamingGetLiveMemosQueryKey = (options) => createQueryKey("streamingGetLiveMemos", options);
export const streamingGetLiveMemosOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamingGetLiveMemos({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: streamingGetLiveMemosQueryKey(options),
    });
};
export const streamingCreateLiveMemoMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await streamingCreateLiveMemo({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const streamingDeleteLiveMemoMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await streamingDeleteLiveMemo({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const streamingUpdateLiveMemoMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await streamingUpdateLiveMemo({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const streamingGetLiveMemoImageUploadUrlQueryKey = (options) => createQueryKey("streamingGetLiveMemoImageUploadUrl", options);
export const streamingGetLiveMemoImageUploadUrlOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamingGetLiveMemoImageUploadUrl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: streamingGetLiveMemoImageUploadUrlQueryKey(options),
    });
};
export const streamingGetBroadcastScreenStateQueryKey = (options) => createQueryKey("streamingGetBroadcastScreenState", options);
export const streamingGetBroadcastScreenStateOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamingGetBroadcastScreenState({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: streamingGetBroadcastScreenStateQueryKey(options),
    });
};
export const streamingGetBroadcastSalesSummaryQueryKey = (options) => createQueryKey("streamingGetBroadcastSalesSummary", options);
export const streamingGetBroadcastSalesSummaryOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamingGetBroadcastSalesSummary({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: streamingGetBroadcastSalesSummaryQueryKey(options),
    });
};
export const streamingGetBroadcastBuyerPresencesQueryKey = (options) => createQueryKey("streamingGetBroadcastBuyerPresences", options);
export const streamingGetBroadcastBuyerPresencesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamingGetBroadcastBuyerPresences({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: streamingGetBroadcastBuyerPresencesQueryKey(options),
    });
};
export const streamingCreateBroadcastBuyerCallMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await streamingCreateBroadcastBuyerCall({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const streamingGetBroadcastViewerListQueryKey = (options) => createQueryKey("streamingGetBroadcastViewerList", options);
export const streamingGetBroadcastViewerListOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamingGetBroadcastViewerList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: streamingGetBroadcastViewerListQueryKey(options),
    });
};
export const streamingGetBroadcastViewerListInfiniteQueryKey = (options) => createQueryKey("streamingGetBroadcastViewerList", options, true);
export const streamingGetBroadcastViewerListInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        cursor: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await streamingGetBroadcastViewerList({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: streamingGetBroadcastViewerListInfiniteQueryKey(options),
    });
};
export const streamingGetAdjacentBroadcastsQueryKey = (options) => createQueryKey("streamingGetAdjacentBroadcasts", options);
export const streamingGetAdjacentBroadcastsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamingGetAdjacentBroadcasts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: streamingGetAdjacentBroadcastsQueryKey(options),
    });
};
export const streamingListDealerBroadcastsQueryKey = (options) => createQueryKey("streamingListDealerBroadcasts", options);
export const streamingListDealerBroadcastsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamingListDealerBroadcasts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: streamingListDealerBroadcastsQueryKey(options),
    });
};
export const streamingListDealerBroadcastsInfiniteQueryKey = (options) => createQueryKey("streamingListDealerBroadcasts", options, true);
export const streamingListDealerBroadcastsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await streamingListDealerBroadcasts({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: streamingListDealerBroadcastsInfiniteQueryKey(options),
    });
};
export const streamingCreateAgoraChannelMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await streamingCreateAgoraChannel({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const streamingCreateAgoraTokenMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await streamingCreateAgoraToken({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const streamingCreateAgoraSessionHeartbeatMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await streamingCreateAgoraSessionHeartbeat({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const streamingDeleteAgoraSessionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await streamingDeleteAgoraSession({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const streamingListBackofficeBroadcastsQueryKey = (options) => createQueryKey("streamingListBackofficeBroadcasts", options);
export const streamingListBackofficeBroadcastsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamingListBackofficeBroadcasts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: streamingListBackofficeBroadcastsQueryKey(options),
    });
};
export const streamingListBackofficeBroadcastsInfiniteQueryKey = (options) => createQueryKey("streamingListBackofficeBroadcasts", options, true);
export const streamingListBackofficeBroadcastsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await streamingListBackofficeBroadcasts({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: streamingListBackofficeBroadcastsInfiniteQueryKey(options),
    });
};
export const streamingDeleteBackofficeBroadcastMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await streamingDeleteBackofficeBroadcast({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const streamingListBackofficeBroadcastChatMessagesQueryKey = (options) => createQueryKey("streamingListBackofficeBroadcastChatMessages", options);
export const streamingListBackofficeBroadcastChatMessagesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamingListBackofficeBroadcastChatMessages({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: streamingListBackofficeBroadcastChatMessagesQueryKey(options),
    });
};
export const streamingListBackofficeBroadcastChatMessagesInfiniteQueryKey = (options) => createQueryKey("streamingListBackofficeBroadcastChatMessages", options, true);
export const streamingListBackofficeBroadcastChatMessagesInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await streamingListBackofficeBroadcastChatMessages({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: streamingListBackofficeBroadcastChatMessagesInfiniteQueryKey(options),
    });
};
export const streamingDeleteBackofficeBroadcastChatMessageMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await streamingDeleteBackofficeBroadcastChatMessage({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const streamingCreateBackofficeBroadcastForceEndMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await streamingCreateBackofficeBroadcastForceEnd({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const streamingDeleteBroadcastReminderMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await streamingDeleteBroadcastReminder({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const streamingGetBroadcastReminderQueryKey = (options) => createQueryKey("streamingGetBroadcastReminder", options);
export const streamingGetBroadcastReminderOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamingGetBroadcastReminder({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: streamingGetBroadcastReminderQueryKey(options),
    });
};
export const streamingCreateBroadcastReminderMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await streamingCreateBroadcastReminder({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const streamingGetBroadcastThumbnailUploadUrlQueryKey = (options) => createQueryKey("streamingGetBroadcastThumbnailUploadUrl", options);
export const streamingGetBroadcastThumbnailUploadUrlOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await streamingGetBroadcastThumbnailUploadUrl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: streamingGetBroadcastThumbnailUploadUrlQueryKey(options),
    });
};
export const messagingListBackofficeSupportChatRoomsQueryKey = (options) => createQueryKey("messagingListBackofficeSupportChatRooms", options);
export const messagingListBackofficeSupportChatRoomsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await messagingListBackofficeSupportChatRooms({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: messagingListBackofficeSupportChatRoomsQueryKey(options),
    });
};
export const messagingListBackofficeSupportChatRoomsInfiniteQueryKey = (options) => createQueryKey("messagingListBackofficeSupportChatRooms", options, true);
export const messagingListBackofficeSupportChatRoomsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await messagingListBackofficeSupportChatRooms({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: messagingListBackofficeSupportChatRoomsInfiniteQueryKey(options),
    });
};
export const messagingCreateBackofficeSupportChatRoomMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await messagingCreateBackofficeSupportChatRoom({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const messagingGetBackofficeSupportChatHistoryQueryKey = (options) => createQueryKey("messagingGetBackofficeSupportChatHistory", options);
export const messagingGetBackofficeSupportChatHistoryOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await messagingGetBackofficeSupportChatHistory({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: messagingGetBackofficeSupportChatHistoryQueryKey(options),
    });
};
export const messagingCreateBackofficeSupportChatMessageMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await messagingCreateBackofficeSupportChatMessage({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const messagingCreateBackofficeSupportChatReadReceiptMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await messagingCreateBackofficeSupportChatReadReceipt({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const messagingListMyChatRoomsQueryKey = (options) => createQueryKey("messagingListMyChatRooms", options);
export const messagingListMyChatRoomsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await messagingListMyChatRooms({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: messagingListMyChatRoomsQueryKey(options),
    });
};
export const messagingListMyChatRoomsInfiniteQueryKey = (options) => createQueryKey("messagingListMyChatRooms", options, true);
export const messagingListMyChatRoomsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await messagingListMyChatRooms({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: messagingListMyChatRoomsInfiniteQueryKey(options),
    });
};
export const messagingListChatRoomsQueryKey = (options) => createQueryKey("messagingListChatRooms", options);
export const messagingListChatRoomsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await messagingListChatRooms({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: messagingListChatRoomsQueryKey(options),
    });
};
export const messagingListChatRoomsInfiniteQueryKey = (options) => createQueryKey("messagingListChatRooms", options, true);
export const messagingListChatRoomsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await messagingListChatRooms({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: messagingListChatRoomsInfiniteQueryKey(options),
    });
};
export const messagingCreateChatRoomMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await messagingCreateChatRoom({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const messagingDeleteChatRoomMembershipMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await messagingDeleteChatRoomMembership({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const messagingGetChatRoomQueryKey = (options) => createQueryKey("messagingGetChatRoom", options);
export const messagingGetChatRoomOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await messagingGetChatRoom({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: messagingGetChatRoomQueryKey(options),
    });
};
export const messagingGetChatHistoryQueryKey = (options) => createQueryKey("messagingGetChatHistory", options);
export const messagingGetChatHistoryOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await messagingGetChatHistory({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: messagingGetChatHistoryQueryKey(options),
    });
};
export const messagingCreateChatRoomMessageMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await messagingCreateChatRoomMessage({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const messagingDeleteMessageMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await messagingDeleteMessage({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const messagingCreateChatRoomImageMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await messagingCreateChatRoomImage({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const messagingCreateChatRoomReadReceiptMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await messagingCreateChatRoomReadReceipt({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const messagingListOpenChatRoomsQueryKey = (options) => createQueryKey("messagingListOpenChatRooms", options);
export const messagingListOpenChatRoomsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await messagingListOpenChatRooms({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: messagingListOpenChatRoomsQueryKey(options),
    });
};
export const messagingListOpenChatRoomsInfiniteQueryKey = (options) => createQueryKey("messagingListOpenChatRooms", options, true);
export const messagingListOpenChatRoomsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await messagingListOpenChatRooms({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: messagingListOpenChatRoomsInfiniteQueryKey(options),
    });
};
export const messagingListCommunityHomeOpenChatRoomsQueryKey = (options) => createQueryKey("messagingListCommunityHomeOpenChatRooms", options);
export const messagingListCommunityHomeOpenChatRoomsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await messagingListCommunityHomeOpenChatRooms({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: messagingListCommunityHomeOpenChatRoomsQueryKey(options),
    });
};
export const messagingDeleteOpenChatRoomMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await messagingDeleteOpenChatRoom({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const messagingGetOpenChatRoomQueryKey = (options) => createQueryKey("messagingGetOpenChatRoom", options);
export const messagingGetOpenChatRoomOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await messagingGetOpenChatRoom({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: messagingGetOpenChatRoomQueryKey(options),
    });
};
export const messagingUpdateOpenChatRoomNoticeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await messagingUpdateOpenChatRoomNotice({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const messagingCreateOpenChatRoomMembershipMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await messagingCreateOpenChatRoomMembership({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const messagingDeleteOpenChatRoomMembershipMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await messagingDeleteOpenChatRoomMembership({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const messagingListOpenChatRoomParticipantsQueryKey = (options) => createQueryKey("messagingListOpenChatRoomParticipants", options);
export const messagingListOpenChatRoomParticipantsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await messagingListOpenChatRoomParticipants({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: messagingListOpenChatRoomParticipantsQueryKey(options),
    });
};
export const messagingListOpenChatRoomParticipantsInfiniteQueryKey = (options) => createQueryKey("messagingListOpenChatRoomParticipants", options, true);
export const messagingListOpenChatRoomParticipantsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await messagingListOpenChatRoomParticipants({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: messagingListOpenChatRoomParticipantsInfiniteQueryKey(options),
    });
};
export const messagingListOpenChatMessagesQueryKey = (options) => createQueryKey("messagingListOpenChatMessages", options);
export const messagingListOpenChatMessagesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await messagingListOpenChatMessages({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: messagingListOpenChatMessagesQueryKey(options),
    });
};
export const messagingCreateOpenChatRoomMessageMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await messagingCreateOpenChatRoomMessage({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const messagingCreateOpenChatImageMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await messagingCreateOpenChatImage({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const messagingDeleteOpenChatRoomMessageMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await messagingDeleteOpenChatRoomMessage({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const messagingListBackofficeOpenChatRoomsQueryKey = (options) => createQueryKey("messagingListBackofficeOpenChatRooms", options);
export const messagingListBackofficeOpenChatRoomsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await messagingListBackofficeOpenChatRooms({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: messagingListBackofficeOpenChatRoomsQueryKey(options),
    });
};
export const messagingListBackofficeOpenChatRoomsInfiniteQueryKey = (options) => createQueryKey("messagingListBackofficeOpenChatRooms", options, true);
export const messagingListBackofficeOpenChatRoomsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await messagingListBackofficeOpenChatRooms({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: messagingListBackofficeOpenChatRoomsInfiniteQueryKey(options),
    });
};
export const messagingCreateBackofficeOpenChatRoomMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await messagingCreateBackofficeOpenChatRoom({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const messagingCreateBackofficeOpenChatRoomCloseMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await messagingCreateBackofficeOpenChatRoomClose({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const messagingListBackofficeMessagesQueryKey = (options) => createQueryKey("messagingListBackofficeMessages", options);
export const messagingListBackofficeMessagesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await messagingListBackofficeMessages({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: messagingListBackofficeMessagesQueryKey(options),
    });
};
export const messagingListBackofficeMessagesInfiniteQueryKey = (options) => createQueryKey("messagingListBackofficeMessages", options, true);
export const messagingListBackofficeMessagesInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await messagingListBackofficeMessages({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: messagingListBackofficeMessagesInfiniteQueryKey(options),
    });
};
export const messagingCreateBackofficeOpenChatRoomKickUserMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await messagingCreateBackofficeOpenChatRoomKickUser({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const messagingCreateBackofficeOpenChatRoomUpdateCategoryMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await messagingCreateBackofficeOpenChatRoomUpdateCategory({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const messagingCreateBackofficeOpenChatRoomUpdateTitleMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await messagingCreateBackofficeOpenChatRoomUpdateTitle({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const messagingCreateBackofficeOpenChatRoomUpdateThumbnailMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await messagingCreateBackofficeOpenChatRoomUpdateThumbnail({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const messagingGetBackofficeOpenChatRoomThumbnailUploadUrlQueryKey = (options) => createQueryKey("messagingGetBackofficeOpenChatRoomThumbnailUploadUrl", options);
export const messagingGetBackofficeOpenChatRoomThumbnailUploadUrlOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await messagingGetBackofficeOpenChatRoomThumbnailUploadUrl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: messagingGetBackofficeOpenChatRoomThumbnailUploadUrlQueryKey(options),
    });
};
export const messagingGetBackofficeOpenChatRoomKickedUsersQueryKey = (options) => createQueryKey("messagingGetBackofficeOpenChatRoomKickedUsers", options);
export const messagingGetBackofficeOpenChatRoomKickedUsersOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await messagingGetBackofficeOpenChatRoomKickedUsers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: messagingGetBackofficeOpenChatRoomKickedUsersQueryKey(options),
    });
};
export const messagingDeleteBackofficeOpenChatRoomKickedUserMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await messagingDeleteBackofficeOpenChatRoomKickedUser({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const messagingGetBackofficeDealerChatRoomSettingsQueryKey = (options) => createQueryKey("messagingGetBackofficeDealerChatRoomSettings", options);
export const messagingGetBackofficeDealerChatRoomSettingsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await messagingGetBackofficeDealerChatRoomSettings({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: messagingGetBackofficeDealerChatRoomSettingsQueryKey(options),
    });
};
export const messagingUpdateBackofficeDealerChatRoomSettingsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await messagingUpdateBackofficeDealerChatRoomSettings({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const messagingListDealerChatRoomsQueryKey = (options) => createQueryKey("messagingListDealerChatRooms", options);
export const messagingListDealerChatRoomsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await messagingListDealerChatRooms({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: messagingListDealerChatRoomsQueryKey(options),
    });
};
export const messagingListDealerChatRoomsInfiniteQueryKey = (options) => createQueryKey("messagingListDealerChatRooms", options, true);
export const messagingListDealerChatRoomsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await messagingListDealerChatRooms({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: messagingListDealerChatRoomsInfiniteQueryKey(options),
    });
};
export const messagingCreateDealerChatRoomMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await messagingCreateDealerChatRoom({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const messagingGetDealerChatRoomCreationEligibilityQueryKey = (options) => createQueryKey("messagingGetDealerChatRoomCreationEligibility", options);
export const messagingGetDealerChatRoomCreationEligibilityOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await messagingGetDealerChatRoomCreationEligibility({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: messagingGetDealerChatRoomCreationEligibilityQueryKey(options),
    });
};
export const messagingCreateDealerChatRoomKickUserMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await messagingCreateDealerChatRoomKickUser({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const messagingListBackofficeOpenChatRoomMessagesQueryKey = (options) => createQueryKey("messagingListBackofficeOpenChatRoomMessages", options);
export const messagingListBackofficeOpenChatRoomMessagesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await messagingListBackofficeOpenChatRoomMessages({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: messagingListBackofficeOpenChatRoomMessagesQueryKey(options),
    });
};
export const messagingListBackofficeOpenChatRoomMessagesInfiniteQueryKey = (options) => createQueryKey("messagingListBackofficeOpenChatRoomMessages", options, true);
export const messagingListBackofficeOpenChatRoomMessagesInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await messagingListBackofficeOpenChatRoomMessages({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: messagingListBackofficeOpenChatRoomMessagesInfiniteQueryKey(options),
    });
};
export const messagingDeleteBackofficeOpenChatRoomMessageMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await messagingDeleteBackofficeOpenChatRoomMessage({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const messagingListBackofficeDmConversationsQueryKey = (options) => createQueryKey("messagingListBackofficeDmConversations", options);
export const messagingListBackofficeDmConversationsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await messagingListBackofficeDmConversations({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: messagingListBackofficeDmConversationsQueryKey(options),
    });
};
export const messagingListBackofficeDmConversationsInfiniteQueryKey = (options) => createQueryKey("messagingListBackofficeDmConversations", options, true);
export const messagingListBackofficeDmConversationsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await messagingListBackofficeDmConversations({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: messagingListBackofficeDmConversationsInfiniteQueryKey(options),
    });
};
export const messagingListBackofficeDmConversationMessagesQueryKey = (options) => createQueryKey("messagingListBackofficeDmConversationMessages", options);
export const messagingListBackofficeDmConversationMessagesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await messagingListBackofficeDmConversationMessages({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: messagingListBackofficeDmConversationMessagesQueryKey(options),
    });
};
export const messagingListBackofficeDmConversationMessagesInfiniteQueryKey = (options) => createQueryKey("messagingListBackofficeDmConversationMessages", options, true);
export const messagingListBackofficeDmConversationMessagesInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await messagingListBackofficeDmConversationMessages({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: messagingListBackofficeDmConversationMessagesInfiniteQueryKey(options),
    });
};
export const notificationListNotificationsQueryKey = (options) => createQueryKey("notificationListNotifications", options);
export const notificationListNotificationsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await notificationListNotifications({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: notificationListNotificationsQueryKey(options),
    });
};
export const notificationListNotificationsInfiniteQueryKey = (options) => createQueryKey("notificationListNotifications", options, true);
export const notificationListNotificationsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await notificationListNotifications({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: notificationListNotificationsInfiniteQueryKey(options),
    });
};
export const notificationPatchNotificationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await notificationPatchNotification({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const notificationCreateNotificationOpenMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await notificationCreateNotificationOpen({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const notificationListUnreadNotificationsQueryKey = (options) => createQueryKey("notificationListUnreadNotifications", options);
export const notificationListUnreadNotificationsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await notificationListUnreadNotifications({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: notificationListUnreadNotificationsQueryKey(options),
    });
};
export const notificationGetNotificationPreferencesQueryKey = (options) => createQueryKey("notificationGetNotificationPreferences", options);
export const notificationGetNotificationPreferencesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await notificationGetNotificationPreferences({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: notificationGetNotificationPreferencesQueryKey(options),
    });
};
export const notificationUpdateNotificationPreferencesMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await notificationUpdateNotificationPreferences({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const notificationUpdateAllNotificationsReadMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await notificationUpdateAllNotificationsRead({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const notificationListBroadcastPushSendHistoriesQueryKey = (options) => createQueryKey("notificationListBroadcastPushSendHistories", options);
export const notificationListBroadcastPushSendHistoriesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await notificationListBroadcastPushSendHistories({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: notificationListBroadcastPushSendHistoriesQueryKey(options),
    });
};
export const notificationListBroadcastPushSendHistoriesInfiniteQueryKey = (options) => createQueryKey("notificationListBroadcastPushSendHistories", options, true);
export const notificationListBroadcastPushSendHistoriesInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await notificationListBroadcastPushSendHistories({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: notificationListBroadcastPushSendHistoriesInfiniteQueryKey(options),
    });
};
export const notificationCreateBroadcastPushSendHistoryMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await notificationCreateBroadcastPushSendHistory({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const notificationListNotificationSettingItemsQueryKey = (options) => createQueryKey("notificationListNotificationSettingItems", options);
export const notificationListNotificationSettingItemsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await notificationListNotificationSettingItems({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: notificationListNotificationSettingItemsQueryKey(options),
    });
};
export const notificationUpdateNotificationSettingItemMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await notificationUpdateNotificationSettingItem({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const notificationListBackofficeNotificationSettingItemsQueryKey = (options) => createQueryKey("notificationListBackofficeNotificationSettingItems", options);
export const notificationListBackofficeNotificationSettingItemsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await notificationListBackofficeNotificationSettingItems({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: notificationListBackofficeNotificationSettingItemsQueryKey(options),
    });
};
export const notificationUpdateBackofficeNotificationSettingItemMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await notificationUpdateBackofficeNotificationSettingItem({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const notificationListBackofficeUserNotificationSettingItemsQueryKey = (options) => createQueryKey("notificationListBackofficeUserNotificationSettingItems", options);
export const notificationListBackofficeUserNotificationSettingItemsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await notificationListBackofficeUserNotificationSettingItems({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: notificationListBackofficeUserNotificationSettingItemsQueryKey(options),
    });
};
export const notificationListBackofficeNotificationsQueryKey = (options) => createQueryKey("notificationListBackofficeNotifications", options);
export const notificationListBackofficeNotificationsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await notificationListBackofficeNotifications({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: notificationListBackofficeNotificationsQueryKey(options),
    });
};
export const notificationListBackofficeNotificationsInfiniteQueryKey = (options) => createQueryKey("notificationListBackofficeNotifications", options, true);
export const notificationListBackofficeNotificationsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await notificationListBackofficeNotifications({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: notificationListBackofficeNotificationsInfiniteQueryKey(options),
    });
};
export const notificationGetNotificationOperationSettingsQueryKey = (options) => createQueryKey("notificationGetNotificationOperationSettings", options);
export const notificationGetNotificationOperationSettingsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await notificationGetNotificationOperationSettings({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: notificationGetNotificationOperationSettingsQueryKey(options),
    });
};
export const notificationUpdateNotificationOperationSettingsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await notificationUpdateNotificationOperationSettings({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const notificationListBackofficeNotificationTemplatesQueryKey = (options) => createQueryKey("notificationListBackofficeNotificationTemplates", options);
export const notificationListBackofficeNotificationTemplatesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await notificationListBackofficeNotificationTemplates({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: notificationListBackofficeNotificationTemplatesQueryKey(options),
    });
};
export const notificationUpdateBackofficeNotificationTemplateMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await notificationUpdateBackofficeNotificationTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const notificationListNotificationDispatchesQueryKey = (options) => createQueryKey("notificationListNotificationDispatches", options);
export const notificationListNotificationDispatchesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await notificationListNotificationDispatches({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: notificationListNotificationDispatchesQueryKey(options),
    });
};
export const notificationListNotificationDispatchesInfiniteQueryKey = (options) => createQueryKey("notificationListNotificationDispatches", options, true);
export const notificationListNotificationDispatchesInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await notificationListNotificationDispatches({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: notificationListNotificationDispatchesInfiniteQueryKey(options),
    });
};
export const notificationCreateNotificationDispatchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await notificationCreateNotificationDispatch({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const notificationCreateNotificationDispatchPreviewMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await notificationCreateNotificationDispatchPreview({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const notificationSearchNotificationDispatchRecipientsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await notificationSearchNotificationDispatchRecipients({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const notificationListNotificationDispatchAlimtalkTemplatesQueryKey = (options) => createQueryKey("notificationListNotificationDispatchAlimtalkTemplates", options);
export const notificationListNotificationDispatchAlimtalkTemplatesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await notificationListNotificationDispatchAlimtalkTemplates({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: notificationListNotificationDispatchAlimtalkTemplatesQueryKey(options),
    });
};
export const notificationCreateNotificationDispatchCancellationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await notificationCreateNotificationDispatchCancellation({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const settlementListSettlementsQueryKey = (options) => createQueryKey("settlementListSettlements", options);
export const settlementListSettlementsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await settlementListSettlements({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: settlementListSettlementsQueryKey(options),
    });
};
export const settlementListSettlementsInfiniteQueryKey = (options) => createQueryKey("settlementListSettlements", options, true);
export const settlementListSettlementsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await settlementListSettlements({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: settlementListSettlementsInfiniteQueryKey(options),
    });
};
export const settlementCreateSettlementMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await settlementCreateSettlement({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const settlementGetSettlementDetailsQueryKey = (options) => createQueryKey("settlementGetSettlementDetails", options);
export const settlementGetSettlementDetailsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await settlementGetSettlementDetails({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: settlementGetSettlementDetailsQueryKey(options),
    });
};
export const settlementCreateSettlementPayoutMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await settlementCreateSettlementPayout({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const settlementUpdatePayoutSuccessMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await settlementUpdatePayoutSuccess({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const settlementUpdatePayoutFailedMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await settlementUpdatePayoutFailed({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const settlementGetSettlementAccountQueryKey = (options) => createQueryKey("settlementGetSettlementAccount", options);
export const settlementGetSettlementAccountOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await settlementGetSettlementAccount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: settlementGetSettlementAccountQueryKey(options),
    });
};
export const settlementCreateSettlementAccountMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await settlementCreateSettlementAccount({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const settlementCreateSettlementReportMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await settlementCreateSettlementReport({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const settlementListBackofficeSettlementsQueryKey = (options) => createQueryKey("settlementListBackofficeSettlements", options);
export const settlementListBackofficeSettlementsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await settlementListBackofficeSettlements({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: settlementListBackofficeSettlementsQueryKey(options),
    });
};
export const settlementListBackofficeSettlementsInfiniteQueryKey = (options) => createQueryKey("settlementListBackofficeSettlements", options, true);
export const settlementListBackofficeSettlementsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await settlementListBackofficeSettlements({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: settlementListBackofficeSettlementsInfiniteQueryKey(options),
    });
};
export const settlementCreateBackofficeSettlementBatchChangeStatusMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await settlementCreateBackofficeSettlementBatchChangeStatus({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const settlementCreateBackofficeSettlementBatchCompletionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await settlementCreateBackofficeSettlementBatchCompletion({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const settlementCreateBackofficeSettlementBatchStartProcessingMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await settlementCreateBackofficeSettlementBatchStartProcessing({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const settlementCreateBackofficeSettlementProcessStartMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await settlementCreateBackofficeSettlementProcessStart({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const settlementCreateBackofficeSettlementProcessCompleteMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await settlementCreateBackofficeSettlementProcessComplete({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const settlementCreateBackofficeSettlementProcessCancelMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await settlementCreateBackofficeSettlementProcessCancel({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const settlementListBackofficeSettlementExportsQueryKey = (options) => createQueryKey("settlementListBackofficeSettlementExports", options);
export const settlementListBackofficeSettlementExportsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await settlementListBackofficeSettlementExports({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: settlementListBackofficeSettlementExportsQueryKey(options),
    });
};
export const settlementGetBackofficeSettlementQueryKey = (options) => createQueryKey("settlementGetBackofficeSettlement", options);
export const settlementGetBackofficeSettlementOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await settlementGetBackofficeSettlement({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: settlementGetBackofficeSettlementQueryKey(options),
    });
};
export const settlementCreateBackofficeSettlementReversalMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await settlementCreateBackofficeSettlementReversal({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const settlementListDealerOffsetsQueryKey = (options) => createQueryKey("settlementListDealerOffsets", options);
export const settlementListDealerOffsetsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await settlementListDealerOffsets({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: settlementListDealerOffsetsQueryKey(options),
    });
};
export const settlementUpdatePaymentAgencyCallbackMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await settlementUpdatePaymentAgencyCallback({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const socialNetworkCreateInvitationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await socialNetworkCreateInvitation({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const socialNetworkUpdateInvitationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await socialNetworkUpdateInvitation({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const socialNetworkListInvitationsQueryKey = (options) => createQueryKey("socialNetworkListInvitations", options);
export const socialNetworkListInvitationsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await socialNetworkListInvitations({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkListInvitationsQueryKey(options),
    });
};
export const socialNetworkListInvitationsInfiniteQueryKey = (options) => createQueryKey("socialNetworkListInvitations", options, true);
export const socialNetworkListInvitationsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await socialNetworkListInvitations({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkListInvitationsInfiniteQueryKey(options),
    });
};
export const socialNetworkCreateUserFollowMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await socialNetworkCreateUserFollow({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const socialNetworkDeleteUserFollowMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await socialNetworkDeleteUserFollow({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const socialNetworkListFollowersQueryKey = (options) => createQueryKey("socialNetworkListFollowers", options);
export const socialNetworkListFollowersOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await socialNetworkListFollowers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkListFollowersQueryKey(options),
    });
};
export const socialNetworkListFollowersInfiniteQueryKey = (options) => createQueryKey("socialNetworkListFollowers", options, true);
export const socialNetworkListFollowersInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await socialNetworkListFollowers({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkListFollowersInfiniteQueryKey(options),
    });
};
export const socialNetworkListFollowingQueryKey = (options) => createQueryKey("socialNetworkListFollowing", options);
export const socialNetworkListFollowingOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await socialNetworkListFollowing({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkListFollowingQueryKey(options),
    });
};
export const socialNetworkListFollowingInfiniteQueryKey = (options) => createQueryKey("socialNetworkListFollowing", options, true);
export const socialNetworkListFollowingInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await socialNetworkListFollowing({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkListFollowingInfiniteQueryKey(options),
    });
};
export const socialNetworkCreateUserBlockMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await socialNetworkCreateUserBlock({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const socialNetworkDeleteUserBlockMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await socialNetworkDeleteUserBlock({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const socialNetworkListBlockedUsersQueryKey = (options) => createQueryKey("socialNetworkListBlockedUsers", options);
export const socialNetworkListBlockedUsersOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await socialNetworkListBlockedUsers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkListBlockedUsersQueryKey(options),
    });
};
export const socialNetworkListBlockedUsersInfiniteQueryKey = (options) => createQueryKey("socialNetworkListBlockedUsers", options, true);
export const socialNetworkListBlockedUsersInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await socialNetworkListBlockedUsers({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkListBlockedUsersInfiniteQueryKey(options),
    });
};
export const socialNetworkCreateReportMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await socialNetworkCreateReport({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const socialNetworkListBackofficeUserBlockedUsersQueryKey = (options) => createQueryKey("socialNetworkListBackofficeUserBlockedUsers", options);
export const socialNetworkListBackofficeUserBlockedUsersOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await socialNetworkListBackofficeUserBlockedUsers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkListBackofficeUserBlockedUsersQueryKey(options),
    });
};
export const socialNetworkListBackofficeUserBlockedUsersInfiniteQueryKey = (options) => createQueryKey("socialNetworkListBackofficeUserBlockedUsers", options, true);
export const socialNetworkListBackofficeUserBlockedUsersInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await socialNetworkListBackofficeUserBlockedUsers({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkListBackofficeUserBlockedUsersInfiniteQueryKey(options),
    });
};
export const socialNetworkGetPublicUserProfileQueryKey = (options) => createQueryKey("socialNetworkGetPublicUserProfile", options);
export const socialNetworkGetPublicUserProfileOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await socialNetworkGetPublicUserProfile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkGetPublicUserProfileQueryKey(options),
    });
};
export const socialNetworkGetPublicFollowerStatsQueryKey = (options) => createQueryKey("socialNetworkGetPublicFollowerStats", options);
export const socialNetworkGetPublicFollowerStatsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await socialNetworkGetPublicFollowerStats({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkGetPublicFollowerStatsQueryKey(options),
    });
};
export const socialNetworkListReportsQueryKey = (options) => createQueryKey("socialNetworkListReports", options);
export const socialNetworkListReportsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await socialNetworkListReports({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkListReportsQueryKey(options),
    });
};
export const socialNetworkListReportsInfiniteQueryKey = (options) => createQueryKey("socialNetworkListReports", options, true);
export const socialNetworkListReportsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await socialNetworkListReports({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkListReportsInfiniteQueryKey(options),
    });
};
export const socialNetworkGetReportQueryKey = (options) => createQueryKey("socialNetworkGetReport", options);
export const socialNetworkGetReportOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await socialNetworkGetReport({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkGetReportQueryKey(options),
    });
};
export const socialNetworkUpdateReportMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await socialNetworkUpdateReport({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const socialNetworkListActiveReportReasonCategoriesQueryKey = (options) => createQueryKey("socialNetworkListActiveReportReasonCategories", options);
export const socialNetworkListActiveReportReasonCategoriesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await socialNetworkListActiveReportReasonCategories({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkListActiveReportReasonCategoriesQueryKey(options),
    });
};
export const socialNetworkListReportReasonCategoriesQueryKey = (options) => createQueryKey("socialNetworkListReportReasonCategories", options);
export const socialNetworkListReportReasonCategoriesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await socialNetworkListReportReasonCategories({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkListReportReasonCategoriesQueryKey(options),
    });
};
export const socialNetworkCreateReportReasonCategoryMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await socialNetworkCreateReportReasonCategory({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const socialNetworkDeleteReportReasonCategoryMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await socialNetworkDeleteReportReasonCategory({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const socialNetworkGetReportReasonCategoryQueryKey = (options) => createQueryKey("socialNetworkGetReportReasonCategory", options);
export const socialNetworkGetReportReasonCategoryOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await socialNetworkGetReportReasonCategory({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkGetReportReasonCategoryQueryKey(options),
    });
};
export const socialNetworkUpdateReportReasonCategoryMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await socialNetworkUpdateReportReasonCategory({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const socialNetworkListLoungePostsQueryKey = (options) => createQueryKey("socialNetworkListLoungePosts", options);
export const socialNetworkListLoungePostsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await socialNetworkListLoungePosts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkListLoungePostsQueryKey(options),
    });
};
export const socialNetworkListLoungePostsInfiniteQueryKey = (options) => createQueryKey("socialNetworkListLoungePosts", options, true);
export const socialNetworkListLoungePostsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await socialNetworkListLoungePosts({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkListLoungePostsInfiniteQueryKey(options),
    });
};
export const socialNetworkCreateLoungePostMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await socialNetworkCreateLoungePost({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const socialNetworkDeleteLoungePostMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await socialNetworkDeleteLoungePost({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const socialNetworkGetLoungePostQueryKey = (options) => createQueryKey("socialNetworkGetLoungePost", options);
export const socialNetworkGetLoungePostOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await socialNetworkGetLoungePost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkGetLoungePostQueryKey(options),
    });
};
export const socialNetworkUpdateLoungePostMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await socialNetworkUpdateLoungePost({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const socialNetworkDeleteLoungePostLikeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await socialNetworkDeleteLoungePostLike({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const socialNetworkCreateLoungePostLikeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await socialNetworkCreateLoungePostLike({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const socialNetworkListLoungeCommentsQueryKey = (options) => createQueryKey("socialNetworkListLoungeComments", options);
export const socialNetworkListLoungeCommentsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await socialNetworkListLoungeComments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkListLoungeCommentsQueryKey(options),
    });
};
export const socialNetworkListLoungeCommentsInfiniteQueryKey = (options) => createQueryKey("socialNetworkListLoungeComments", options, true);
export const socialNetworkListLoungeCommentsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await socialNetworkListLoungeComments({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkListLoungeCommentsInfiniteQueryKey(options),
    });
};
export const socialNetworkCreateLoungeCommentMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await socialNetworkCreateLoungeComment({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const socialNetworkDeleteLoungeCommentMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await socialNetworkDeleteLoungeComment({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const socialNetworkUpdateLoungeCommentMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await socialNetworkUpdateLoungeComment({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const socialNetworkListLoungeCommentRepliesQueryKey = (options) => createQueryKey("socialNetworkListLoungeCommentReplies", options);
export const socialNetworkListLoungeCommentRepliesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await socialNetworkListLoungeCommentReplies({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkListLoungeCommentRepliesQueryKey(options),
    });
};
export const socialNetworkListLoungeCommentRepliesInfiniteQueryKey = (options) => createQueryKey("socialNetworkListLoungeCommentReplies", options, true);
export const socialNetworkListLoungeCommentRepliesInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await socialNetworkListLoungeCommentReplies({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkListLoungeCommentRepliesInfiniteQueryKey(options),
    });
};
export const socialNetworkCreateLoungeCommentReplyMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await socialNetworkCreateLoungeCommentReply({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const socialNetworkDeleteLoungeCommentLikeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await socialNetworkDeleteLoungeCommentLike({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const socialNetworkCreateLoungeCommentLikeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await socialNetworkCreateLoungeCommentLike({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const socialNetworkListMyLoungeCommentsQueryKey = (options) => createQueryKey("socialNetworkListMyLoungeComments", options);
export const socialNetworkListMyLoungeCommentsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await socialNetworkListMyLoungeComments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkListMyLoungeCommentsQueryKey(options),
    });
};
export const socialNetworkListMyLoungeCommentsInfiniteQueryKey = (options) => createQueryKey("socialNetworkListMyLoungeComments", options, true);
export const socialNetworkListMyLoungeCommentsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await socialNetworkListMyLoungeComments({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkListMyLoungeCommentsInfiniteQueryKey(options),
    });
};
export const socialNetworkGetLoungePostImageUploadUrlQueryKey = (options) => createQueryKey("socialNetworkGetLoungePostImageUploadUrl", options);
export const socialNetworkGetLoungePostImageUploadUrlOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await socialNetworkGetLoungePostImageUploadUrl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkGetLoungePostImageUploadUrlQueryKey(options),
    });
};
export const socialNetworkGetMyReferralLinkQueryKey = (options) => createQueryKey("socialNetworkGetMyReferralLink", options);
export const socialNetworkGetMyReferralLinkOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await socialNetworkGetMyReferralLink({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkGetMyReferralLinkQueryKey(options),
    });
};
export const socialNetworkCreateMyReferralLinkMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await socialNetworkCreateMyReferralLink({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const socialNetworkGetMyReferralStatsQueryKey = (options) => createQueryKey("socialNetworkGetMyReferralStats", options);
export const socialNetworkGetMyReferralStatsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await socialNetworkGetMyReferralStats({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkGetMyReferralStatsQueryKey(options),
    });
};
export const socialNetworkListMyReferredUsersQueryKey = (options) => createQueryKey("socialNetworkListMyReferredUsers", options);
export const socialNetworkListMyReferredUsersOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await socialNetworkListMyReferredUsers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkListMyReferredUsersQueryKey(options),
    });
};
export const socialNetworkListMyReferredUsersInfiniteQueryKey = (options) => createQueryKey("socialNetworkListMyReferredUsers", options, true);
export const socialNetworkListMyReferredUsersInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await socialNetworkListMyReferredUsers({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkListMyReferredUsersInfiniteQueryKey(options),
    });
};
export const socialNetworkListBackofficeLoungePostsQueryKey = (options) => createQueryKey("socialNetworkListBackofficeLoungePosts", options);
export const socialNetworkListBackofficeLoungePostsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await socialNetworkListBackofficeLoungePosts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkListBackofficeLoungePostsQueryKey(options),
    });
};
export const socialNetworkListBackofficeLoungePostsInfiniteQueryKey = (options) => createQueryKey("socialNetworkListBackofficeLoungePosts", options, true);
export const socialNetworkListBackofficeLoungePostsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await socialNetworkListBackofficeLoungePosts({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkListBackofficeLoungePostsInfiniteQueryKey(options),
    });
};
export const socialNetworkGetBackofficeLoungePostQueryKey = (options) => createQueryKey("socialNetworkGetBackofficeLoungePost", options);
export const socialNetworkGetBackofficeLoungePostOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await socialNetworkGetBackofficeLoungePost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkGetBackofficeLoungePostQueryKey(options),
    });
};
export const socialNetworkCreateBackofficeLoungePostDeletionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await socialNetworkCreateBackofficeLoungePostDeletion({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const socialNetworkCreateBackofficeLoungePostPinMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await socialNetworkCreateBackofficeLoungePostPin({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const socialNetworkCreateBackofficeLoungePostUnpinMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await socialNetworkCreateBackofficeLoungePostUnpin({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const socialNetworkListBackofficeLoungePostCommentsQueryKey = (options) => createQueryKey("socialNetworkListBackofficeLoungePostComments", options);
export const socialNetworkListBackofficeLoungePostCommentsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await socialNetworkListBackofficeLoungePostComments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkListBackofficeLoungePostCommentsQueryKey(options),
    });
};
export const socialNetworkListBackofficeLoungePostCommentsInfiniteQueryKey = (options) => createQueryKey("socialNetworkListBackofficeLoungePostComments", options, true);
export const socialNetworkListBackofficeLoungePostCommentsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await socialNetworkListBackofficeLoungePostComments({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkListBackofficeLoungePostCommentsInfiniteQueryKey(options),
    });
};
export const socialNetworkListBackofficeLoungeCommentRepliesQueryKey = (options) => createQueryKey("socialNetworkListBackofficeLoungeCommentReplies", options);
export const socialNetworkListBackofficeLoungeCommentRepliesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await socialNetworkListBackofficeLoungeCommentReplies({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkListBackofficeLoungeCommentRepliesQueryKey(options),
    });
};
export const socialNetworkListBackofficeLoungeCommentRepliesInfiniteQueryKey = (options) => createQueryKey("socialNetworkListBackofficeLoungeCommentReplies", options, true);
export const socialNetworkListBackofficeLoungeCommentRepliesInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await socialNetworkListBackofficeLoungeCommentReplies({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: socialNetworkListBackofficeLoungeCommentRepliesInfiniteQueryKey(options),
    });
};
export const socialNetworkCreateBackofficeLoungeCommentDeletionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await socialNetworkCreateBackofficeLoungeCommentDeletion({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const liveSnapshotListLiveSnapshotsQueryKey = (options) => createQueryKey("liveSnapshotListLiveSnapshots", options);
export const liveSnapshotListLiveSnapshotsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await liveSnapshotListLiveSnapshots({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: liveSnapshotListLiveSnapshotsQueryKey(options),
    });
};
export const liveSnapshotListLiveSnapshotsInfiniteQueryKey = (options) => createQueryKey("liveSnapshotListLiveSnapshots", options, true);
export const liveSnapshotListLiveSnapshotsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        cursor: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await liveSnapshotListLiveSnapshots({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: liveSnapshotListLiveSnapshotsInfiniteQueryKey(options),
    });
};
export const liveSnapshotCreateLiveSnapshotMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await liveSnapshotCreateLiveSnapshot({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const liveSnapshotGetLiveSnapshotImageUploadUrlQueryKey = (options) => createQueryKey("liveSnapshotGetLiveSnapshotImageUploadUrl", options);
export const liveSnapshotGetLiveSnapshotImageUploadUrlOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await liveSnapshotGetLiveSnapshotImageUploadUrl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: liveSnapshotGetLiveSnapshotImageUploadUrlQueryKey(options),
    });
};
export const liveSnapshotListLiveSnapshotBuyersQueryKey = (options) => createQueryKey("liveSnapshotListLiveSnapshotBuyers", options);
export const liveSnapshotListLiveSnapshotBuyersOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await liveSnapshotListLiveSnapshotBuyers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: liveSnapshotListLiveSnapshotBuyersQueryKey(options),
    });
};
export const liveSnapshotGetLiveSnapshotQueryKey = (options) => createQueryKey("liveSnapshotGetLiveSnapshot", options);
export const liveSnapshotGetLiveSnapshotOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await liveSnapshotGetLiveSnapshot({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: liveSnapshotGetLiveSnapshotQueryKey(options),
    });
};
export const liveSnapshotDeleteLiveSnapshotMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await liveSnapshotDeleteLiveSnapshot({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const liveSnapshotListBackofficeLiveSnapshotsQueryKey = (options) => createQueryKey("liveSnapshotListBackofficeLiveSnapshots", options);
export const liveSnapshotListBackofficeLiveSnapshotsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await liveSnapshotListBackofficeLiveSnapshots({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: liveSnapshotListBackofficeLiveSnapshotsQueryKey(options),
    });
};
export const liveSnapshotListBackofficeLiveSnapshotsInfiniteQueryKey = (options) => createQueryKey("liveSnapshotListBackofficeLiveSnapshots", options, true);
export const liveSnapshotListBackofficeLiveSnapshotsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await liveSnapshotListBackofficeLiveSnapshots({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: liveSnapshotListBackofficeLiveSnapshotsInfiniteQueryKey(options),
    });
};
export const liveSnapshotGetBackofficeLiveSnapshotQueryKey = (options) => createQueryKey("liveSnapshotGetBackofficeLiveSnapshot", options);
export const liveSnapshotGetBackofficeLiveSnapshotOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await liveSnapshotGetBackofficeLiveSnapshot({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: liveSnapshotGetBackofficeLiveSnapshotQueryKey(options),
    });
};
export const liveSnapshotPatchBackofficeLiveSnapshotHideStatusMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await liveSnapshotPatchBackofficeLiveSnapshotHideStatus({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const liveSnapshotPatchBackofficeLiveSnapshotUnhideStatusMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await liveSnapshotPatchBackofficeLiveSnapshotUnhideStatus({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ledgerListAccountsQueryKey = (options) => createQueryKey("ledgerListAccounts", options);
export const ledgerListAccountsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ledgerListAccounts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ledgerListAccountsQueryKey(options),
    });
};
export const ledgerListAccountsInfiniteQueryKey = (options) => createQueryKey("ledgerListAccounts", options, true);
export const ledgerListAccountsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await ledgerListAccounts({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ledgerListAccountsInfiniteQueryKey(options),
    });
};
export const ledgerCreateAccountMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ledgerCreateAccount({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ledgerDeleteAccountMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ledgerDeleteAccount({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ledgerGetAccountQueryKey = (options) => createQueryKey("ledgerGetAccount", options);
export const ledgerGetAccountOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ledgerGetAccount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ledgerGetAccountQueryKey(options),
    });
};
export const ledgerUpdateAccountMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ledgerUpdateAccount({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ledgerGetAccountBalanceQueryKey = (options) => createQueryKey("ledgerGetAccountBalance", options);
export const ledgerGetAccountBalanceOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ledgerGetAccountBalance({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ledgerGetAccountBalanceQueryKey(options),
    });
};
export const ledgerListJournalEntriesQueryKey = (options) => createQueryKey("ledgerListJournalEntries", options);
export const ledgerListJournalEntriesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ledgerListJournalEntries({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ledgerListJournalEntriesQueryKey(options),
    });
};
export const ledgerListJournalEntriesInfiniteQueryKey = (options) => createQueryKey("ledgerListJournalEntries", options, true);
export const ledgerListJournalEntriesInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await ledgerListJournalEntries({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ledgerListJournalEntriesInfiniteQueryKey(options),
    });
};
export const ledgerCreateJournalEntryMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ledgerCreateJournalEntry({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ledgerGetJournalEntryQueryKey = (options) => createQueryKey("ledgerGetJournalEntry", options);
export const ledgerGetJournalEntryOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ledgerGetJournalEntry({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ledgerGetJournalEntryQueryKey(options),
    });
};
export const ledgerCreateReversingJournalEntryMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ledgerCreateReversingJournalEntry({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ledgerListReconciliationReportsQueryKey = (options) => createQueryKey("ledgerListReconciliationReports", options);
export const ledgerListReconciliationReportsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ledgerListReconciliationReports({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ledgerListReconciliationReportsQueryKey(options),
    });
};
export const ledgerListReconciliationReportsInfiniteQueryKey = (options) => createQueryKey("ledgerListReconciliationReports", options, true);
export const ledgerListReconciliationReportsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await ledgerListReconciliationReports({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ledgerListReconciliationReportsInfiniteQueryKey(options),
    });
};
export const ledgerCreateReconciliationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ledgerCreateReconciliation({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ledgerGetReconciliationReportQueryKey = (options) => createQueryKey("ledgerGetReconciliationReport", options);
export const ledgerGetReconciliationReportOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ledgerGetReconciliationReport({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ledgerGetReconciliationReportQueryKey(options),
    });
};
export const ledgerListDiscrepanciesQueryKey = (options) => createQueryKey("ledgerListDiscrepancies", options);
export const ledgerListDiscrepanciesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ledgerListDiscrepancies({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ledgerListDiscrepanciesQueryKey(options),
    });
};
export const ledgerListDiscrepanciesInfiniteQueryKey = (options) => createQueryKey("ledgerListDiscrepancies", options, true);
export const ledgerListDiscrepanciesInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await ledgerListDiscrepancies({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ledgerListDiscrepanciesInfiniteQueryKey(options),
    });
};
export const ledgerGetDealerBalanceQueryKey = (options) => createQueryKey("ledgerGetDealerBalance", options);
export const ledgerGetDealerBalanceOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ledgerGetDealerBalance({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ledgerGetDealerBalanceQueryKey(options),
    });
};
export const ledgerGetTrialBalanceQueryKey = (options) => createQueryKey("ledgerGetTrialBalance", options);
export const ledgerGetTrialBalanceOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ledgerGetTrialBalance({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ledgerGetTrialBalanceQueryKey(options),
    });
};
export const ledgerCreateControlAccountReconciliationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await ledgerCreateControlAccountReconciliation({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const pointGetMyPointBalanceQueryKey = (options) => createQueryKey("pointGetMyPointBalance", options);
export const pointGetMyPointBalanceOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await pointGetMyPointBalance({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: pointGetMyPointBalanceQueryKey(options),
    });
};
export const pointListMyPointTransactionsQueryKey = (options) => createQueryKey("pointListMyPointTransactions", options);
export const pointListMyPointTransactionsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await pointListMyPointTransactions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: pointListMyPointTransactionsQueryKey(options),
    });
};
export const pointListMyPointTransactionsInfiniteQueryKey = (options) => createQueryKey("pointListMyPointTransactions", options, true);
export const pointListMyPointTransactionsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await pointListMyPointTransactions({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: pointListMyPointTransactionsInfiniteQueryKey(options),
    });
};
export const pointGetBackofficeUserPointBalanceQueryKey = (options) => createQueryKey("pointGetBackofficeUserPointBalance", options);
export const pointGetBackofficeUserPointBalanceOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await pointGetBackofficeUserPointBalance({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: pointGetBackofficeUserPointBalanceQueryKey(options),
    });
};
export const pointListBackofficeUserPointTransactionsQueryKey = (options) => createQueryKey("pointListBackofficeUserPointTransactions", options);
export const pointListBackofficeUserPointTransactionsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await pointListBackofficeUserPointTransactions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: pointListBackofficeUserPointTransactionsQueryKey(options),
    });
};
export const pointListBackofficeUserPointTransactionsInfiniteQueryKey = (options) => createQueryKey("pointListBackofficeUserPointTransactions", options, true);
export const pointListBackofficeUserPointTransactionsInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await pointListBackofficeUserPointTransactions({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: pointListBackofficeUserPointTransactionsInfiniteQueryKey(options),
    });
};
export const pointCreateBackofficeUserPointCreditMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await pointCreateBackofficeUserPointCredit({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const pointCreateBackofficeUserPointDebitMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await pointCreateBackofficeUserPointDebit({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const marketplacePaymentGetCallbackQueryKey = (options) => createQueryKey("marketplacePaymentGetCallback", options);
export const marketplacePaymentGetCallbackOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await marketplacePaymentGetCallback({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: marketplacePaymentGetCallbackQueryKey(options),
    });
};
export const marketplacePaymentListBrandPayPaymentMethodsQueryKey = (options) => createQueryKey("marketplacePaymentListBrandPayPaymentMethods", options);
export const marketplacePaymentListBrandPayPaymentMethodsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await marketplacePaymentListBrandPayPaymentMethods({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: marketplacePaymentListBrandPayPaymentMethodsQueryKey(options),
    });
};
export const marketplacePaymentCreateBrandPayPaymentMethodDefaultMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await marketplacePaymentCreateBrandPayPaymentMethodDefault({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const marketplacePaymentDeleteBrandPayPaymentMethodMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await marketplacePaymentDeleteBrandPayPaymentMethod({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const marketplacePaymentGetBrandPayRegistrationStatusQueryKey = (options) => createQueryKey("marketplacePaymentGetBrandPayRegistrationStatus", options);
export const marketplacePaymentGetBrandPayRegistrationStatusOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await marketplacePaymentGetBrandPayRegistrationStatus({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: marketplacePaymentGetBrandPayRegistrationStatusQueryKey(options),
    });
};
export const contentManagementListBannersQueryKey = (options) => createQueryKey("contentManagementListBanners", options);
export const contentManagementListBannersOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await contentManagementListBanners({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: contentManagementListBannersQueryKey(options),
    });
};
export const contentManagementCreateBannerMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await contentManagementCreateBanner({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const contentManagementUpdateBannerDisplayOrdersMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await contentManagementUpdateBannerDisplayOrders({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const contentManagementGetBannerImageUploadUrlQueryKey = (options) => createQueryKey("contentManagementGetBannerImageUploadUrl", options);
export const contentManagementGetBannerImageUploadUrlOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await contentManagementGetBannerImageUploadUrl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: contentManagementGetBannerImageUploadUrlQueryKey(options),
    });
};
export const contentManagementDeleteBannerMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await contentManagementDeleteBanner({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const contentManagementGetBannerQueryKey = (options) => createQueryKey("contentManagementGetBanner", options);
export const contentManagementGetBannerOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await contentManagementGetBanner({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: contentManagementGetBannerQueryKey(options),
    });
};
export const contentManagementUpdateBannerMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await contentManagementUpdateBanner({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const contentManagementListPublicBannersQueryKey = (options) => createQueryKey("contentManagementListPublicBanners", options);
export const contentManagementListPublicBannersOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await contentManagementListPublicBanners({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: contentManagementListPublicBannersQueryKey(options),
    });
};
export const contentManagementListNoticesQueryKey = (options) => createQueryKey("contentManagementListNotices", options);
export const contentManagementListNoticesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await contentManagementListNotices({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: contentManagementListNoticesQueryKey(options),
    });
};
export const contentManagementCreateNoticeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await contentManagementCreateNotice({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const contentManagementDeleteNoticeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await contentManagementDeleteNotice({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const contentManagementGetNoticeQueryKey = (options) => createQueryKey("contentManagementGetNotice", options);
export const contentManagementGetNoticeOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await contentManagementGetNotice({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: contentManagementGetNoticeQueryKey(options),
    });
};
export const contentManagementUpdateNoticeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await contentManagementUpdateNotice({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const contentManagementGetContentFileUploadUrlQueryKey = (options) => createQueryKey("contentManagementGetContentFileUploadUrl", options);
export const contentManagementGetContentFileUploadUrlOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await contentManagementGetContentFileUploadUrl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: contentManagementGetContentFileUploadUrlQueryKey(options),
    });
};
export const contentManagementListContentPagesQueryKey = (options) => createQueryKey("contentManagementListContentPages", options);
export const contentManagementListContentPagesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await contentManagementListContentPages({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: contentManagementListContentPagesQueryKey(options),
    });
};
export const contentManagementCreateContentPageMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await contentManagementCreateContentPage({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const contentManagementDeleteContentPageMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await contentManagementDeleteContentPage({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const contentManagementGetContentPageQueryKey = (options) => createQueryKey("contentManagementGetContentPage", options);
export const contentManagementGetContentPageOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await contentManagementGetContentPage({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: contentManagementGetContentPageQueryKey(options),
    });
};
export const contentManagementUpdateContentPageMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await contentManagementUpdateContentPage({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const contentManagementListPublicNoticesQueryKey = (options) => createQueryKey("contentManagementListPublicNotices", options);
export const contentManagementListPublicNoticesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await contentManagementListPublicNotices({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: contentManagementListPublicNoticesQueryKey(options),
    });
};
export const contentManagementListPublicNoticesInfiniteQueryKey = (options) => createQueryKey("contentManagementListPublicNotices", options, true);
export const contentManagementListPublicNoticesInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await contentManagementListPublicNotices({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: contentManagementListPublicNoticesInfiniteQueryKey(options),
    });
};
export const contentManagementGetPublicNoticeQueryKey = (options) => createQueryKey("contentManagementGetPublicNotice", options);
export const contentManagementGetPublicNoticeOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await contentManagementGetPublicNotice({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: contentManagementGetPublicNoticeQueryKey(options),
    });
};
export const contentManagementListPublicNoticePopupsQueryKey = (options) => createQueryKey("contentManagementListPublicNoticePopups", options);
export const contentManagementListPublicNoticePopupsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await contentManagementListPublicNoticePopups({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: contentManagementListPublicNoticePopupsQueryKey(options),
    });
};
export const contentManagementListPublicNoticeBannersQueryKey = (options) => createQueryKey("contentManagementListPublicNoticeBanners", options);
export const contentManagementListPublicNoticeBannersOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await contentManagementListPublicNoticeBanners({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: contentManagementListPublicNoticeBannersQueryKey(options),
    });
};
export const contentManagementGetPublicContentPageQueryKey = (options) => createQueryKey("contentManagementGetPublicContentPage", options);
export const contentManagementGetPublicContentPageOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await contentManagementGetPublicContentPage({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: contentManagementGetPublicContentPageQueryKey(options),
    });
};
export const platformConfigGetCommissionConfigQueryKey = (options) => createQueryKey("platformConfigGetCommissionConfig", options);
export const platformConfigGetCommissionConfigOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await platformConfigGetCommissionConfig({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: platformConfigGetCommissionConfigQueryKey(options),
    });
};
export const platformConfigUpdateCommissionConfigMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await platformConfigUpdateCommissionConfig({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const platformConfigGetPgFeeConfigQueryKey = (options) => createQueryKey("platformConfigGetPgFeeConfig", options);
export const platformConfigGetPgFeeConfigOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await platformConfigGetPgFeeConfig({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: platformConfigGetPgFeeConfigQueryKey(options),
    });
};
export const platformConfigUpdatePgFeeConfigMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await platformConfigUpdatePgFeeConfig({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const platformConfigGetSettlementConfigQueryKey = (options) => createQueryKey("platformConfigGetSettlementConfig", options);
export const platformConfigGetSettlementConfigOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await platformConfigGetSettlementConfig({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: platformConfigGetSettlementConfigQueryKey(options),
    });
};
export const platformConfigUpdateSettlementConfigMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await platformConfigUpdateSettlementConfig({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const platformConfigGetFeeRatesQueryKey = (options) => createQueryKey("platformConfigGetFeeRates", options);
export const platformConfigGetFeeRatesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await platformConfigGetFeeRates({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: platformConfigGetFeeRatesQueryKey(options),
    });
};
export const platformConfigGetAppVersionPoliciesQueryKey = (options) => createQueryKey("platformConfigGetAppVersionPolicies", options);
export const platformConfigGetAppVersionPoliciesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await platformConfigGetAppVersionPolicies({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: platformConfigGetAppVersionPoliciesQueryKey(options),
    });
};
export const platformConfigUpdateAppVersionPolicyMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await platformConfigUpdateAppVersionPolicy({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const platformConfigGetBoltbMarketSectionAllowedCategoriesQueryKey = (options) => createQueryKey("platformConfigGetBoltbMarketSectionAllowedCategories", options);
export const platformConfigGetBoltbMarketSectionAllowedCategoriesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await platformConfigGetBoltbMarketSectionAllowedCategories({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: platformConfigGetBoltbMarketSectionAllowedCategoriesQueryKey(options),
    });
};
export const platformConfigUpdateBoltbMarketSectionAllowedCategoriesMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await platformConfigUpdateBoltbMarketSectionAllowedCategories({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const platformConfigGetMobileRuntimePoliciesQueryKey = (options) => createQueryKey("platformConfigGetMobileRuntimePolicies", options);
export const platformConfigGetMobileRuntimePoliciesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await platformConfigGetMobileRuntimePolicies({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: platformConfigGetMobileRuntimePoliciesQueryKey(options),
    });
};
export const platformConfigUpdateMobileRuntimePolicyMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await platformConfigUpdateMobileRuntimePolicy({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const platformConfigGetCompanyInfoQueryKey = (options) => createQueryKey("platformConfigGetCompanyInfo", options);
export const platformConfigGetCompanyInfoOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await platformConfigGetCompanyInfo({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: platformConfigGetCompanyInfoQueryKey(options),
    });
};
export const platformConfigUpdateCompanyInfoMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await platformConfigUpdateCompanyInfo({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const platformConfigGetAppDownloadSettingsQueryKey = (options) => createQueryKey("platformConfigGetAppDownloadSettings", options);
export const platformConfigGetAppDownloadSettingsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await platformConfigGetAppDownloadSettings({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: platformConfigGetAppDownloadSettingsQueryKey(options),
    });
};
export const platformConfigUpdateAppDownloadSettingsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await platformConfigUpdateAppDownloadSettings({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const platformConfigGetBroadcastChatNoticesQueryKey = (options) => createQueryKey("platformConfigGetBroadcastChatNotices", options);
export const platformConfigGetBroadcastChatNoticesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await platformConfigGetBroadcastChatNotices({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: platformConfigGetBroadcastChatNoticesQueryKey(options),
    });
};
export const platformConfigCreateBroadcastChatNoticeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await platformConfigCreateBroadcastChatNotice({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const platformConfigUpdateBroadcastChatNoticeOrderMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await platformConfigUpdateBroadcastChatNoticeOrder({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const platformConfigUpdateBroadcastChatNoticeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await platformConfigUpdateBroadcastChatNotice({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const platformConfigGetBroadcastChatNoticeSettingsQueryKey = (options) => createQueryKey("platformConfigGetBroadcastChatNoticeSettings", options);
export const platformConfigGetBroadcastChatNoticeSettingsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await platformConfigGetBroadcastChatNoticeSettings({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: platformConfigGetBroadcastChatNoticeSettingsQueryKey(options),
    });
};
export const platformConfigUpdateBroadcastChatNoticeSettingsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await platformConfigUpdateBroadcastChatNoticeSettings({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const platformConfigListChatBannedWordsQueryKey = (options) => createQueryKey("platformConfigListChatBannedWords", options);
export const platformConfigListChatBannedWordsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await platformConfigListChatBannedWords({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: platformConfigListChatBannedWordsQueryKey(options),
    });
};
export const platformConfigCreateChatBannedWordMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await platformConfigCreateChatBannedWord({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const platformConfigDeleteChatBannedWordMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await platformConfigDeleteChatBannedWord({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const platformConfigGetAppUiSettingsQueryKey = (options) => createQueryKey("platformConfigGetAppUiSettings", options);
export const platformConfigGetAppUiSettingsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await platformConfigGetAppUiSettings({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: platformConfigGetAppUiSettingsQueryKey(options),
    });
};
export const platformConfigUpdateAppUiSettingsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await platformConfigUpdateAppUiSettings({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const platformConfigCreateAppUiSettingResetMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await platformConfigCreateAppUiSettingReset({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const platformConfigListUiConfigFilesQueryKey = (options) => createQueryKey("platformConfigListUiConfigFiles", options);
export const platformConfigListUiConfigFilesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await platformConfigListUiConfigFiles({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: platformConfigListUiConfigFilesQueryKey(options),
    });
};
export const platformConfigGetUiConfigFileQueryKey = (options) => createQueryKey("platformConfigGetUiConfigFile", options);
export const platformConfigGetUiConfigFileOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await platformConfigGetUiConfigFile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: platformConfigGetUiConfigFileQueryKey(options),
    });
};
export const platformConfigDeleteUiConfigDraftMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await platformConfigDeleteUiConfigDraft({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const platformConfigUpdateUiConfigDraftMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await platformConfigUpdateUiConfigDraft({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const platformConfigCreateUiConfigPublishMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await platformConfigCreateUiConfigPublish({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const platformConfigCreateUiConfigRevertMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await platformConfigCreateUiConfigRevert({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const platformConfigUpdateUiConfigSwitchesMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await platformConfigUpdateUiConfigSwitches({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const platformConfigGetPublicMobileRuntimePolicyQueryKey = (options) => createQueryKey("platformConfigGetPublicMobileRuntimePolicy", options);
export const platformConfigGetPublicMobileRuntimePolicyOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await platformConfigGetPublicMobileRuntimePolicy({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: platformConfigGetPublicMobileRuntimePolicyQueryKey(options),
    });
};
export const platformConfigGetPublicAppVersionPoliciesQueryKey = (options) => createQueryKey("platformConfigGetPublicAppVersionPolicies", options);
export const platformConfigGetPublicAppVersionPoliciesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await platformConfigGetPublicAppVersionPolicies({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: platformConfigGetPublicAppVersionPoliciesQueryKey(options),
    });
};
export const platformConfigGetPublicBoltbMarketSectionAllowedCategoriesQueryKey = (options) => createQueryKey("platformConfigGetPublicBoltbMarketSectionAllowedCategories", options);
export const platformConfigGetPublicBoltbMarketSectionAllowedCategoriesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await platformConfigGetPublicBoltbMarketSectionAllowedCategories({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: platformConfigGetPublicBoltbMarketSectionAllowedCategoriesQueryKey(options),
    });
};
export const platformConfigGetPublicCompanyInfoQueryKey = (options) => createQueryKey("platformConfigGetPublicCompanyInfo", options);
export const platformConfigGetPublicCompanyInfoOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await platformConfigGetPublicCompanyInfo({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: platformConfigGetPublicCompanyInfoQueryKey(options),
    });
};
export const platformConfigGetPublicAppDownloadSettingsQueryKey = (options) => createQueryKey("platformConfigGetPublicAppDownloadSettings", options);
export const platformConfigGetPublicAppDownloadSettingsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await platformConfigGetPublicAppDownloadSettings({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: platformConfigGetPublicAppDownloadSettingsQueryKey(options),
    });
};
export const platformConfigGetPublicBroadcastChatNoticeSettingsQueryKey = (options) => createQueryKey("platformConfigGetPublicBroadcastChatNoticeSettings", options);
export const platformConfigGetPublicBroadcastChatNoticeSettingsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await platformConfigGetPublicBroadcastChatNoticeSettings({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: platformConfigGetPublicBroadcastChatNoticeSettingsQueryKey(options),
    });
};
export const platformConfigGetAppSyncChangesQueryKey = (options) => createQueryKey("platformConfigGetAppSyncChanges", options);
export const platformConfigGetAppSyncChangesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await platformConfigGetAppSyncChanges({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: platformConfigGetAppSyncChangesQueryKey(options),
    });
};
export const platformConfigGetPublicUiConfigManifestQueryKey = (options) => createQueryKey("platformConfigGetPublicUiConfigManifest", options);
export const platformConfigGetPublicUiConfigManifestOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await platformConfigGetPublicUiConfigManifest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: platformConfigGetPublicUiConfigManifestQueryKey(options),
    });
};
export const platformConfigGetPublicUiConfigVersionQueryKey = (options) => createQueryKey("platformConfigGetPublicUiConfigVersion", options);
export const platformConfigGetPublicUiConfigVersionOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await platformConfigGetPublicUiConfigVersion({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: platformConfigGetPublicUiConfigVersionQueryKey(options),
    });
};
export const platformConfigGetPublicPageQueryKey = (options) => createQueryKey("platformConfigGetPublicPage", options);
export const platformConfigGetPublicPageOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await platformConfigGetPublicPage({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: platformConfigGetPublicPageQueryKey(options),
    });
};
export const categoryListPublicCategoriesQueryKey = (options) => createQueryKey("categoryListPublicCategories", options);
export const categoryListPublicCategoriesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await categoryListPublicCategories({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: categoryListPublicCategoriesQueryKey(options),
    });
};
export const categoryListCategoriesQueryKey = (options) => createQueryKey("categoryListCategories", options);
export const categoryListCategoriesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await categoryListCategories({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: categoryListCategoriesQueryKey(options),
    });
};
export const categoryCreateCategoryMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await categoryCreateCategory({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const categoryDeleteCategoryMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await categoryDeleteCategory({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const categoryGetCategoryQueryKey = (options) => createQueryKey("categoryGetCategory", options);
export const categoryGetCategoryOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await categoryGetCategory({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: categoryGetCategoryQueryKey(options),
    });
};
export const categoryUpdateCategoryMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await categoryUpdateCategory({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const categoryGetCategoryImageUploadUrlQueryKey = (options) => createQueryKey("categoryGetCategoryImageUploadUrl", options);
export const categoryGetCategoryImageUploadUrlOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await categoryGetCategoryImageUploadUrl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: categoryGetCategoryImageUploadUrlQueryKey(options),
    });
};
export const categoryGetAllCategoryIconSettingQueryKey = (options) => createQueryKey("categoryGetAllCategoryIconSetting", options);
export const categoryGetAllCategoryIconSettingOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await categoryGetAllCategoryIconSetting({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: categoryGetAllCategoryIconSettingQueryKey(options),
    });
};
export const categoryUpdateAllCategoryIconSettingMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await categoryUpdateAllCategoryIconSetting({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const kpiGetBackofficeKpiDashboardQueryKey = (options) => createQueryKey("kpiGetBackofficeKpiDashboard", options);
export const kpiGetBackofficeKpiDashboardOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await kpiGetBackofficeKpiDashboard({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: kpiGetBackofficeKpiDashboardQueryKey(options),
    });
};
export const kpiListBackofficeKpiDashboardExportsQueryKey = (options) => createQueryKey("kpiListBackofficeKpiDashboardExports", options);
export const kpiListBackofficeKpiDashboardExportsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await kpiListBackofficeKpiDashboardExports({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: kpiListBackofficeKpiDashboardExportsQueryKey(options),
    });
};
export const dealerBackofficeGetDashboardSummaryQueryKey = (options) => createQueryKey("dealerBackofficeGetDashboardSummary", options);
export const dealerBackofficeGetDashboardSummaryOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await dealerBackofficeGetDashboardSummary({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: dealerBackofficeGetDashboardSummaryQueryKey(options),
    });
};
export const dealerBackofficeListSalesHistoryQueryKey = (options) => createQueryKey("dealerBackofficeListSalesHistory", options);
export const dealerBackofficeListSalesHistoryOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await dealerBackofficeListSalesHistory({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: dealerBackofficeListSalesHistoryQueryKey(options),
    });
};
export const dealerBackofficeListSalesHistoryInfiniteQueryKey = (options) => createQueryKey("dealerBackofficeListSalesHistory", options, true);
export const dealerBackofficeListSalesHistoryInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await dealerBackofficeListSalesHistory({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: dealerBackofficeListSalesHistoryInfiniteQueryKey(options),
    });
};
export const dealerBackofficeGetBuyerNewOrderGroupQueryKey = (options) => createQueryKey("dealerBackofficeGetBuyerNewOrderGroup", options);
export const dealerBackofficeGetBuyerNewOrderGroupOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await dealerBackofficeGetBuyerNewOrderGroup({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: dealerBackofficeGetBuyerNewOrderGroupQueryKey(options),
    });
};
export const dealerBackofficeListBuyerHistoriesQueryKey = (options) => createQueryKey("dealerBackofficeListBuyerHistories", options);
export const dealerBackofficeListBuyerHistoriesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await dealerBackofficeListBuyerHistories({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: dealerBackofficeListBuyerHistoriesQueryKey(options),
    });
};
export const dealerBackofficeListBuyerHistoriesInfiniteQueryKey = (options) => createQueryKey("dealerBackofficeListBuyerHistories", options, true);
export const dealerBackofficeListBuyerHistoriesInfiniteOptions = (options) => {
    return infiniteQueryOptions({
        queryFn: async ({ pageParam, queryKey, signal }) => {
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await dealerBackofficeListBuyerHistories({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: dealerBackofficeListBuyerHistoriesInfiniteQueryKey(options),
    });
};
//# sourceMappingURL=react-query.gen.js.map